// Web CRM (Business plane) PAGE-BODY i18n dictionary — STATIC UI CHROME ONLY.
// Merged into the flat per-language lookup by ./translations.js (same t() semantics, no new dep).
//
// SCOPE: visible static labels on Business pages (Billing, Marketplace, Showroom, Customers,
// Create Survey, Category Management, Director/Executive/IT dashboards). NEVER used for
// dynamic/backend/user content (business/customer names, product data, prices, brand IDs,
// API enums, generated text). Common buttons/status reuse the `common.*` keys — not redefined here.
//
// English is the default + fallback. Every language below carries the IDENTICAL key set.

const pagesTranslations = {
  en: {
    // ---- Billing ----
    'pg.billing.title': 'Billing & Subscription',
    'pg.billing.subtitle': 'Manage your plan, view invoices, and upgrade or downgrade.',
    'pg.billing.currentPlan': 'Current Plan',
    'pg.billing.currentPlanDesc': 'Your active subscription and key limits.',
    'pg.billing.tier': 'Tier',
    'pg.billing.price': 'Price',
    'pg.billing.brandId': 'Brand ID',
    'pg.billing.status': 'Status',
    'pg.billing.users': 'Users',
    'pg.billing.engagements': 'Engagements / mo',
    'pg.billing.storage': 'Storage',
    'pg.billing.changePlan': 'Change Plan',
    'pg.billing.changePlanDesc': "Pick a new tier — you'll be redirected to secure Stripe checkout.",
    'pg.billing.current': 'Current',
    'pg.billing.onRequest': 'On request',
    'pg.billing.contactSales': 'Contact sales',
    'pg.billing.switchPlan': 'Switch to this plan',
    'pg.billing.currentPlanBtn': 'Current plan',
    'pg.billing.redirecting': 'Redirecting…',
    'pg.billing.managePayments': 'Manage Payment Methods & Cancellations',
    'pg.billing.managePaymentsDesc': "Open Stripe's secure customer portal to update your card, download receipts, or cancel your subscription.",
    'pg.billing.openingStripe': 'Opening Stripe…',
    'pg.billing.redirectingCheckout': 'Redirecting to checkout…',
    'pg.billing.openPortal': 'Open Stripe Customer Portal',
    'pg.billing.portalNotice': 'No active paid subscription yet — clicking will open secure Stripe checkout to activate your plan. After payment the portal is available immediately.',
    'pg.billing.invoiceHistory': 'Invoice History',
    'pg.billing.invoiceHistoryDesc': 'Your most recent Stripe checkout sessions.',
    'pg.billing.noInvoices': 'No invoices yet.',
    'pg.billing.upgradeToStart': 'Upgrade to a paid plan to start billing.',
    'pg.billing.date': 'Date',
    'pg.billing.amount': 'Amount',
    'pg.billing.intent': 'Intent',
    'pg.billing.invoice': 'Invoice',
    'pg.billing.receipt': 'Receipt',
    'pg.billing.downloadPdf': 'Download PDF',
    'pg.billing.downloading': 'Downloading…',
    'pg.billing.stepUpPrompt': 'Enter the 6-digit code from your authenticator to download this receipt.',
    'pg.billing.notAuthorised': 'Your role does not have access to billing documents.',
    'pg.billing.receiptUnavailable': 'This receipt is not available.',
    'pg.billing.enterCode': 'Enter the 6-digit code.',
    'pg.billing.codeIncorrect': 'That code is incorrect. Try the current code.',
    'pg.billing.paymentsSecure': 'Payments processed securely by Stripe.',
    // ---- Marketplace ----
    'pg.mkt.searchPlaceholder': 'Search products, services, or businesses...',
    'pg.mkt.allCategories': 'All Categories',
    'pg.mkt.location': 'Location',
    'pg.mkt.recommended': 'Recommended for You',
    'pg.mkt.noRecommendations': 'No recommendations yet.',
    'pg.mkt.browseCategories': 'Browse Categories',
    'pg.mkt.searchResultsFor': 'Search results for "{query}"',
    'pg.mkt.allProducts': 'All Products',
    'pg.mkt.productsFound': 'products found',
    'pg.mkt.newestFirst': 'Newest First',
    'pg.mkt.priceLowHigh': 'Price: Low to High',
    'pg.mkt.priceHighLow': 'Price: High to Low',
    'pg.mkt.noPriceMatch': 'No products on this page match your price filter.',
    'pg.mkt.page': 'Page',
    'pg.mkt.noProductsFound': 'No products found',
    'pg.mkt.adjustSearch': 'Try adjusting your search criteria or browse different categories.',
    'pg.mkt.clearFilters': 'Clear Filters',
    'pg.mkt.productDetailsInfo': 'Product details and information',
    'pg.mkt.description': 'Description',
    'pg.mkt.price': 'Price',
    'pg.mkt.tags': 'Tags',
    'pg.mkt.contactForPrice': 'Contact for Price',
    'pg.mkt.addToFavorites': 'Add to Favorites',
    'pg.mkt.contactBusiness': 'Contact Business',
    'pg.mkt.contactBusinessSoon': 'Messaging a business directly from the marketplace is coming soon.',
    'pg.mkt.filterProducts': 'Filter Products',
    'pg.mkt.refineSearch': 'Refine your search with advanced filters',
    'pg.mkt.priceRange': 'Price Range',
    'pg.mkt.min': 'Min',
    'pg.mkt.max': 'Max',
    'pg.mkt.category': 'Category',
    'pg.mkt.selectCategory': 'Select category',
    'pg.mkt.clearAll': 'Clear All',
    'pg.mkt.applyFilters': 'Apply Filters',
    // ---- Showroom ----
    'pg.showroom.createTitle': 'Create Your Business Showroom',
    'pg.showroom.createSubtitle': 'Set up your marketplace presence and start showcasing your products and services',
    'pg.showroom.basicInfo': 'Basic Information',
    'pg.showroom.businessNameReq': 'Business Name *',
    'pg.showroom.enterBusinessName': 'Enter your business name',
    'pg.showroom.descriptionReq': 'Description *',
    'pg.showroom.describeBusiness': 'Describe your business and what you offer',
    'pg.showroom.location': 'Location',
    'pg.showroom.businessAddress': 'Business Address',
    'pg.showroom.enterAddress': 'Enter your business address',
    'pg.showroom.locationVerified': 'Location verified',
    'pg.showroom.contactOptions': 'Contact Options',
    'pg.showroom.email': 'Email',
    'pg.showroom.phone': 'Phone',
    'pg.showroom.enableChat': 'Enable Chat Support',
    'pg.showroom.enableCalling': 'Enable In-App Calling',
    'pg.showroom.createShowroom': 'Create Showroom',
    'pg.showroom.managerTitle': 'Showroom Manager',
    'pg.showroom.managerSubtitle': 'Manage your business presence in the marketplace',
    'pg.showroom.editShowroom': 'Edit Showroom',
    'pg.showroom.saveChanges': 'Save Changes',
    'pg.showroom.showroomInfo': 'Showroom Information',
    'pg.showroom.productsServices': 'Products & Services',
    'pg.showroom.addProduct': 'Add Product',
    'pg.showroom.all': 'All',
    'pg.showroom.active': 'Active',
    'pg.showroom.hidden': 'Hidden',
    'pg.showroom.noProductsYet': 'No products yet',
    'pg.showroom.noActiveProducts': 'No active products',
    'pg.showroom.noHiddenProducts': 'No hidden products',
    'pg.showroom.startShowcasing': 'Start showcasing your products and services in the marketplace.',
    'pg.showroom.addFirstProduct': 'Add Your First Product',
    'pg.showroom.analyticsOverview': 'Analytics Overview',
    'pg.showroom.totalViews': 'Total Views',
    'pg.showroom.products': 'Products',
    'pg.showroom.rating': 'Rating',
    'pg.showroom.viewFullAnalytics': 'View Full Analytics',
    // ---- Customers ----
    'pg.customers.failedLoad': 'Failed to load customers',
    'pg.customers.noConversation': 'No Conversation Found',
    'pg.customers.callInitiated': 'Call Initiated',
    'pg.customers.callLogged': 'Call Logged',
    // ---- Create Survey ----
    'pg.survey.createSurvey': 'Create Survey',
    'pg.survey.subtitle': 'Create engaging surveys to gather customer feedback',
    'pg.survey.multipleChoice': 'Multiple Choice',
    'pg.survey.textResponse': 'Text Response',
    'pg.survey.ratingScale': 'Rating Scale',
    'pg.survey.yesNo': 'Yes/No',
    'pg.survey.enterQuestion': 'Please enter a question before adding',
    'pg.survey.questionAdded': 'Question Added',
    'pg.survey.questionAddedDesc': 'Question has been added to the survey',
    'pg.survey.missingInfo': 'Missing Information',
    'pg.survey.missingInfoDesc': 'Please fill in all required fields and add at least one question',
    'pg.survey.surveyCreated': 'Survey Created!',
    'pg.survey.surveyCreatedDesc': 'Your survey has been created successfully and is now available to customers',
    'pg.survey.createFailed': 'Failed to create survey. Please try again.',
    // ---- Category Management ----
    'pg.category.authNotReady': 'Authentication not ready',
    'pg.category.refreshTryAgain': 'Please refresh and try again.',
    'pg.category.failedLoadCategories': 'Failed to load feedback categories',
    'pg.category.customizationSaved': 'Category customization saved successfully',
    'pg.category.title': 'Feedback Category Management',
    'pg.category.subtitle': 'Manage and customize feedback categories for your business',
    // ---- Director Dashboard ----
    'pg.director.title': 'Director Dashboard',
    'pg.director.livePerf': 'Live team performance —',
    'pg.director.teamProductivity': 'Team Productivity',
    'pg.director.workloadDistribution': 'Workload Distribution',
    'pg.director.departmentKpis': 'Department KPIs',
    'pg.director.resolutionRate': 'Resolution Rate',
    'pg.director.ticketsResolved': 'Tickets Resolved',
    'pg.director.thisPeriod': 'This period',
    'pg.director.avgFirstResponse': 'Avg First Response',
    'pg.director.avgResolution': 'Avg resolution',
    'pg.director.dailyResVsEsc': 'Daily Resolution vs Escalation',
    'pg.director.liveUnavailable': 'Live analytics are temporarily unavailable. Please retry.',
    'pg.director.workspaceNotLinked': 'Your account is not linked to a workspace yet, so analytics cannot load. Contact your administrator if this is unexpected.',
    // ---- Executive Dashboard ----
    'pg.exec.title': 'Executive Dashboard',
    'pg.exec.liveMetrics': 'Live operational metrics —',
    'pg.exec.days7': '7 Days',
    'pg.exec.days30': '30 Days',
    'pg.exec.days90': '90 Days',
    'pg.exec.totalCustomers': 'Total Customers',
    'pg.exec.registeredPlatform': 'Registered in platform',
    'pg.exec.aiResolutionRate': 'AI Resolution Rate',
    'pg.exec.chatAutoResolved': 'Chat auto-resolved',
    'pg.exec.customerCsat': 'Customer CSAT',
    'pg.exec.noRatingsYet': 'No ratings yet',
    'pg.exec.escalationRate': 'Escalation Rate',
    'pg.exec.failedLoad': 'Failed to load dashboard data',
    // ---- IT Dashboard ----
    'pg.it.title': 'IT Dashboard',
    'pg.it.tenantIntegrationOps': 'Tenant integration operations —',
    'pg.it.tenantScopedNotice': 'Tenant-scoped data only. Platform/system infrastructure health is managed by Servisfy and is not shown here.',
    'pg.it.connectors': 'Connectors',
    'pg.it.loading': 'Loading…',
    'pg.it.failedConnectors': 'Failed to load connectors.',
    'pg.it.noConnectors': 'No connectors configured yet.',
    'pg.it.openIntegrationHub': 'Open Integration Hub',
    'pg.it.activeConfigured': '{active} active / {configured} configured',
    'pg.it.enabled': 'Enabled',
    'pg.it.disabled': 'Disabled',
    'pg.it.dataVolume': 'Data Volume',
    'pg.it.conversations': 'Conversations',
    'pg.it.escalations': 'Escalations',
    'pg.it.liveTenantCounts': 'Live tenant record counts (IT-scoped).',
    'pg.it.workspaceNotLinked': 'Your account is not linked to a workspace yet, so tenant data cannot load. Contact your administrator if this is unexpected.',
  },
  es: {
    'pg.billing.title': 'Facturación y suscripción',
    'pg.billing.subtitle': 'Gestione su plan, consulte facturas y cambie a un plan superior o inferior.',
    'pg.billing.currentPlan': 'Plan actual',
    'pg.billing.currentPlanDesc': 'Su suscripción activa y los límites principales.',
    'pg.billing.tier': 'Nivel',
    'pg.billing.price': 'Precio',
    'pg.billing.brandId': 'ID de marca',
    'pg.billing.status': 'Estado',
    'pg.billing.users': 'Usuarios',
    'pg.billing.engagements': 'Interacciones / mes',
    'pg.billing.storage': 'Almacenamiento',
    'pg.billing.changePlan': 'Cambiar de plan',
    'pg.billing.changePlanDesc': 'Elija un nuevo nivel — se le redirigirá al pago seguro de Stripe.',
    'pg.billing.current': 'Actual',
    'pg.billing.onRequest': 'Según solicitud',
    'pg.billing.contactSales': 'Contactar con ventas',
    'pg.billing.switchPlan': 'Cambiar a este plan',
    'pg.billing.currentPlanBtn': 'Plan actual',
    'pg.billing.redirecting': 'Redirigiendo…',
    'pg.billing.managePayments': 'Gestionar métodos de pago y cancelaciones',
    'pg.billing.managePaymentsDesc': 'Abra el portal de clientes seguro de Stripe para actualizar su tarjeta, descargar recibos o cancelar su suscripción.',
    'pg.billing.openingStripe': 'Abriendo Stripe…',
    'pg.billing.redirectingCheckout': 'Redirigiendo al pago…',
    'pg.billing.openPortal': 'Abrir el portal de clientes de Stripe',
    'pg.billing.portalNotice': 'Aún no hay una suscripción de pago activa — al hacer clic se abrirá el pago seguro de Stripe para activar su plan. Tras el pago, el portal estará disponible de inmediato.',
    'pg.billing.invoiceHistory': 'Historial de facturas',
    'pg.billing.invoiceHistoryDesc': 'Sus sesiones de pago de Stripe más recientes.',
    'pg.billing.noInvoices': 'Todavía no hay facturas.',
    'pg.billing.upgradeToStart': 'Cambie a un plan de pago para comenzar a facturar.',
    'pg.billing.date': 'Fecha',
    'pg.billing.amount': 'Importe',
    'pg.billing.intent': 'Propósito',
    'pg.billing.paymentsSecure': 'Pagos procesados de forma segura por Stripe.',
    'pg.mkt.searchPlaceholder': 'Buscar productos, servicios o empresas...',
    'pg.mkt.allCategories': 'Todas las categorías',
    'pg.mkt.location': 'Ubicación',
    'pg.mkt.recommended': 'Recomendado para usted',
    'pg.mkt.noRecommendations': 'Aún no hay recomendaciones.',
    'pg.mkt.browseCategories': 'Explorar categorías',
    'pg.mkt.searchResultsFor': 'Resultados de búsqueda para "{query}"',
    'pg.mkt.allProducts': 'Todos los productos',
    'pg.mkt.productsFound': 'productos encontrados',
    'pg.mkt.newestFirst': 'Más recientes primero',
    'pg.mkt.priceLowHigh': 'Precio: de menor a mayor',
    'pg.mkt.priceHighLow': 'Precio: de mayor a menor',
    'pg.mkt.noPriceMatch': 'Ningún producto de esta página coincide con su filtro de precio.',
    'pg.mkt.page': 'Página',
    'pg.mkt.noProductsFound': 'No se encontraron productos',
    'pg.mkt.adjustSearch': 'Pruebe a ajustar sus criterios de búsqueda o explore otras categorías.',
    'pg.mkt.clearFilters': 'Borrar filtros',
    'pg.mkt.productDetailsInfo': 'Detalles e información del producto',
    'pg.mkt.description': 'Descripción',
    'pg.mkt.price': 'Precio',
    'pg.mkt.tags': 'Etiquetas',
    'pg.mkt.contactForPrice': 'Consultar precio',
    'pg.mkt.addToFavorites': 'Añadir a favoritos',
    'pg.mkt.contactBusiness': 'Contactar con la empresa',
    'pg.mkt.contactBusinessSoon': 'La mensajería directa con una empresa desde el mercado estará disponible pronto.',
    'pg.mkt.filterProducts': 'Filtrar productos',
    'pg.mkt.refineSearch': 'Refine su búsqueda con filtros avanzados',
    'pg.mkt.priceRange': 'Rango de precios',
    'pg.mkt.min': 'Mín',
    'pg.mkt.max': 'Máx',
    'pg.mkt.category': 'Categoría',
    'pg.mkt.selectCategory': 'Seleccionar categoría',
    'pg.mkt.clearAll': 'Borrar todo',
    'pg.mkt.applyFilters': 'Aplicar filtros',
    'pg.showroom.createTitle': 'Cree su sala de exposición empresarial',
    'pg.showroom.createSubtitle': 'Configure su presencia en el mercado y comience a mostrar sus productos y servicios',
    'pg.showroom.basicInfo': 'Información básica',
    'pg.showroom.businessNameReq': 'Nombre de la empresa *',
    'pg.showroom.enterBusinessName': 'Introduzca el nombre de su empresa',
    'pg.showroom.descriptionReq': 'Descripción *',
    'pg.showroom.describeBusiness': 'Describa su empresa y lo que ofrece',
    'pg.showroom.location': 'Ubicación',
    'pg.showroom.businessAddress': 'Dirección de la empresa',
    'pg.showroom.enterAddress': 'Introduzca la dirección de su empresa',
    'pg.showroom.locationVerified': 'Ubicación verificada',
    'pg.showroom.contactOptions': 'Opciones de contacto',
    'pg.showroom.email': 'Correo electrónico',
    'pg.showroom.phone': 'Teléfono',
    'pg.showroom.enableChat': 'Habilitar soporte por chat',
    'pg.showroom.enableCalling': 'Habilitar llamadas en la app',
    'pg.showroom.createShowroom': 'Crear sala de exposición',
    'pg.showroom.managerTitle': 'Gestor de sala de exposición',
    'pg.showroom.managerSubtitle': 'Gestione la presencia de su empresa en el mercado',
    'pg.showroom.editShowroom': 'Editar sala de exposición',
    'pg.showroom.saveChanges': 'Guardar cambios',
    'pg.showroom.showroomInfo': 'Información de la sala de exposición',
    'pg.showroom.productsServices': 'Productos y servicios',
    'pg.showroom.addProduct': 'Añadir producto',
    'pg.showroom.all': 'Todos',
    'pg.showroom.active': 'Activos',
    'pg.showroom.hidden': 'Ocultos',
    'pg.showroom.noProductsYet': 'Aún no hay productos',
    'pg.showroom.noActiveProducts': 'No hay productos activos',
    'pg.showroom.noHiddenProducts': 'No hay productos ocultos',
    'pg.showroom.startShowcasing': 'Comience a mostrar sus productos y servicios en el mercado.',
    'pg.showroom.addFirstProduct': 'Añada su primer producto',
    'pg.showroom.analyticsOverview': 'Resumen de analíticas',
    'pg.showroom.totalViews': 'Vistas totales',
    'pg.showroom.products': 'Productos',
    'pg.showroom.rating': 'Valoración',
    'pg.showroom.viewFullAnalytics': 'Ver analíticas completas',
    'pg.customers.failedLoad': 'No se pudieron cargar los clientes',
    'pg.customers.noConversation': 'No se encontró ninguna conversación',
    'pg.customers.callInitiated': 'Llamada iniciada',
    'pg.customers.callLogged': 'Llamada registrada',
    'pg.survey.createSurvey': 'Crear encuesta',
    'pg.survey.subtitle': 'Cree encuestas atractivas para recopilar comentarios de los clientes',
    'pg.survey.multipleChoice': 'Opción múltiple',
    'pg.survey.textResponse': 'Respuesta de texto',
    'pg.survey.ratingScale': 'Escala de valoración',
    'pg.survey.yesNo': 'Sí/No',
    'pg.survey.enterQuestion': 'Introduzca una pregunta antes de añadirla',
    'pg.survey.questionAdded': 'Pregunta añadida',
    'pg.survey.questionAddedDesc': 'La pregunta se ha añadido a la encuesta',
    'pg.survey.missingInfo': 'Falta información',
    'pg.survey.missingInfoDesc': 'Complete todos los campos obligatorios y añada al menos una pregunta',
    'pg.survey.surveyCreated': '¡Encuesta creada!',
    'pg.survey.surveyCreatedDesc': 'Su encuesta se ha creado correctamente y ya está disponible para los clientes',
    'pg.survey.createFailed': 'No se pudo crear la encuesta. Inténtelo de nuevo.',
    'pg.category.authNotReady': 'Autenticación no lista',
    'pg.category.refreshTryAgain': 'Actualice la página e inténtelo de nuevo.',
    'pg.category.failedLoadCategories': 'No se pudieron cargar las categorías de comentarios',
    'pg.category.customizationSaved': 'Personalización de categoría guardada correctamente',
    'pg.category.title': 'Gestión de categorías de comentarios',
    'pg.category.subtitle': 'Gestione y personalice las categorías de comentarios de su empresa',
    'pg.director.title': 'Panel del director',
    'pg.director.livePerf': 'Rendimiento del equipo en vivo —',
    'pg.director.teamProductivity': 'Productividad del equipo',
    'pg.director.workloadDistribution': 'Distribución de la carga de trabajo',
    'pg.director.departmentKpis': 'KPI del departamento',
    'pg.director.resolutionRate': 'Tasa de resolución',
    'pg.director.ticketsResolved': 'Tickets resueltos',
    'pg.director.thisPeriod': 'Este período',
    'pg.director.avgFirstResponse': 'Primera respuesta media',
    'pg.director.avgResolution': 'Resolución media',
    'pg.director.dailyResVsEsc': 'Resolución vs. escalación diaria',
    'pg.director.liveUnavailable': 'Las analíticas en vivo no están disponibles temporalmente. Inténtelo de nuevo.',
    'pg.director.workspaceNotLinked': 'Su cuenta aún no está vinculada a un espacio de trabajo, por lo que no se pueden cargar las analíticas. Contacte con su administrador si esto es inesperado.',
    'pg.exec.title': 'Panel ejecutivo',
    'pg.exec.liveMetrics': 'Métricas operativas en vivo —',
    'pg.exec.days7': '7 días',
    'pg.exec.days30': '30 días',
    'pg.exec.days90': '90 días',
    'pg.exec.totalCustomers': 'Clientes totales',
    'pg.exec.registeredPlatform': 'Registrados en la plataforma',
    'pg.exec.aiResolutionRate': 'Tasa de resolución por IA',
    'pg.exec.chatAutoResolved': 'Chat resuelto automáticamente',
    'pg.exec.customerCsat': 'CSAT del cliente',
    'pg.exec.noRatingsYet': 'Aún no hay valoraciones',
    'pg.exec.escalationRate': 'Tasa de escalación',
    'pg.exec.failedLoad': 'No se pudieron cargar los datos del panel',
    'pg.it.title': 'Panel de TI',
    'pg.it.tenantIntegrationOps': 'Operaciones de integración del inquilino —',
    'pg.it.tenantScopedNotice': 'Solo datos del inquilino. El estado de la infraestructura de la plataforma/sistema lo gestiona Servisfy y no se muestra aquí.',
    'pg.it.connectors': 'Conectores',
    'pg.it.loading': 'Cargando…',
    'pg.it.failedConnectors': 'No se pudieron cargar los conectores.',
    'pg.it.noConnectors': 'Aún no hay conectores configurados.',
    'pg.it.openIntegrationHub': 'Abrir el centro de integración',
    'pg.it.activeConfigured': '{active} activos / {configured} configurados',
    'pg.it.enabled': 'Habilitado',
    'pg.it.disabled': 'Deshabilitado',
    'pg.it.dataVolume': 'Volumen de datos',
    'pg.it.conversations': 'Conversaciones',
    'pg.it.escalations': 'Escalaciones',
    'pg.it.liveTenantCounts': 'Recuentos de registros del inquilino en vivo (ámbito de TI).',
    'pg.it.workspaceNotLinked': 'Su cuenta aún no está vinculada a un espacio de trabajo, por lo que no se pueden cargar los datos del inquilino. Contacte con su administrador si esto es inesperado.',
  },
  fr: {
    'pg.billing.title': 'Facturation et abonnement',
    'pg.billing.subtitle': 'Gérez votre forfait, consultez vos factures et changez de niveau supérieur ou inférieur.',
    'pg.billing.currentPlan': 'Forfait actuel',
    'pg.billing.currentPlanDesc': 'Votre abonnement actif et les limites principales.',
    'pg.billing.tier': 'Niveau',
    'pg.billing.price': 'Prix',
    'pg.billing.brandId': 'ID de marque',
    'pg.billing.status': 'Statut',
    'pg.billing.users': 'Utilisateurs',
    'pg.billing.engagements': 'Interactions / mois',
    'pg.billing.storage': 'Stockage',
    'pg.billing.changePlan': 'Changer de forfait',
    'pg.billing.changePlanDesc': 'Choisissez un nouveau niveau — vous serez redirigé vers le paiement sécurisé Stripe.',
    'pg.billing.current': 'Actuel',
    'pg.billing.onRequest': 'Sur demande',
    'pg.billing.contactSales': 'Contacter le service commercial',
    'pg.billing.switchPlan': 'Passer à ce forfait',
    'pg.billing.currentPlanBtn': 'Forfait actuel',
    'pg.billing.redirecting': 'Redirection…',
    'pg.billing.managePayments': 'Gérer les moyens de paiement et les annulations',
    'pg.billing.managePaymentsDesc': 'Ouvrez le portail client sécurisé de Stripe pour mettre à jour votre carte, télécharger des reçus ou annuler votre abonnement.',
    'pg.billing.openingStripe': 'Ouverture de Stripe…',
    'pg.billing.redirectingCheckout': 'Redirection vers le paiement…',
    'pg.billing.openPortal': 'Ouvrir le portail client Stripe',
    'pg.billing.portalNotice': "Aucun abonnement payant actif pour le moment — un clic ouvrira le paiement sécurisé Stripe pour activer votre forfait. Après le paiement, le portail est disponible immédiatement.",
    'pg.billing.invoiceHistory': 'Historique des factures',
    'pg.billing.invoiceHistoryDesc': 'Vos sessions de paiement Stripe les plus récentes.',
    'pg.billing.noInvoices': 'Aucune facture pour le moment.',
    'pg.billing.upgradeToStart': 'Passez à un forfait payant pour commencer la facturation.',
    'pg.billing.date': 'Date',
    'pg.billing.amount': 'Montant',
    'pg.billing.intent': 'Objet',
    'pg.billing.paymentsSecure': 'Paiements traités en toute sécurité par Stripe.',
    'pg.mkt.searchPlaceholder': 'Rechercher des produits, services ou entreprises...',
    'pg.mkt.allCategories': 'Toutes les catégories',
    'pg.mkt.location': 'Emplacement',
    'pg.mkt.recommended': 'Recommandé pour vous',
    'pg.mkt.noRecommendations': 'Aucune recommandation pour le moment.',
    'pg.mkt.browseCategories': 'Parcourir les catégories',
    'pg.mkt.searchResultsFor': 'Résultats de recherche pour "{query}"',
    'pg.mkt.allProducts': 'Tous les produits',
    'pg.mkt.productsFound': 'produits trouvés',
    'pg.mkt.newestFirst': 'Plus récents d\'abord',
    'pg.mkt.priceLowHigh': 'Prix : croissant',
    'pg.mkt.priceHighLow': 'Prix : décroissant',
    'pg.mkt.noPriceMatch': 'Aucun produit de cette page ne correspond à votre filtre de prix.',
    'pg.mkt.page': 'Page',
    'pg.mkt.noProductsFound': 'Aucun produit trouvé',
    'pg.mkt.adjustSearch': 'Essayez d\'ajuster vos critères de recherche ou de parcourir d\'autres catégories.',
    'pg.mkt.clearFilters': 'Effacer les filtres',
    'pg.mkt.productDetailsInfo': 'Détails et informations du produit',
    'pg.mkt.description': 'Description',
    'pg.mkt.price': 'Prix',
    'pg.mkt.tags': 'Étiquettes',
    'pg.mkt.contactForPrice': 'Prix sur demande',
    'pg.mkt.addToFavorites': 'Ajouter aux favoris',
    'pg.mkt.contactBusiness': 'Contacter l\'entreprise',
    'pg.mkt.contactBusinessSoon': 'La messagerie directe avec une entreprise depuis la place de marché arrive bientôt.',
    'pg.mkt.filterProducts': 'Filtrer les produits',
    'pg.mkt.refineSearch': 'Affinez votre recherche avec des filtres avancés',
    'pg.mkt.priceRange': 'Fourchette de prix',
    'pg.mkt.min': 'Min',
    'pg.mkt.max': 'Max',
    'pg.mkt.category': 'Catégorie',
    'pg.mkt.selectCategory': 'Sélectionner une catégorie',
    'pg.mkt.clearAll': 'Tout effacer',
    'pg.mkt.applyFilters': 'Appliquer les filtres',
    'pg.showroom.createTitle': 'Créez la vitrine de votre entreprise',
    'pg.showroom.createSubtitle': 'Configurez votre présence sur la place de marché et commencez à présenter vos produits et services',
    'pg.showroom.basicInfo': 'Informations de base',
    'pg.showroom.businessNameReq': 'Nom de l\'entreprise *',
    'pg.showroom.enterBusinessName': 'Saisissez le nom de votre entreprise',
    'pg.showroom.descriptionReq': 'Description *',
    'pg.showroom.describeBusiness': 'Décrivez votre entreprise et ce que vous proposez',
    'pg.showroom.location': 'Emplacement',
    'pg.showroom.businessAddress': 'Adresse de l\'entreprise',
    'pg.showroom.enterAddress': 'Saisissez l\'adresse de votre entreprise',
    'pg.showroom.locationVerified': 'Emplacement vérifié',
    'pg.showroom.contactOptions': 'Options de contact',
    'pg.showroom.email': 'E-mail',
    'pg.showroom.phone': 'Téléphone',
    'pg.showroom.enableChat': 'Activer l\'assistance par chat',
    'pg.showroom.enableCalling': 'Activer les appels dans l\'application',
    'pg.showroom.createShowroom': 'Créer la vitrine',
    'pg.showroom.managerTitle': 'Gestionnaire de vitrine',
    'pg.showroom.managerSubtitle': 'Gérez la présence de votre entreprise sur la place de marché',
    'pg.showroom.editShowroom': 'Modifier la vitrine',
    'pg.showroom.saveChanges': 'Enregistrer les modifications',
    'pg.showroom.showroomInfo': 'Informations sur la vitrine',
    'pg.showroom.productsServices': 'Produits et services',
    'pg.showroom.addProduct': 'Ajouter un produit',
    'pg.showroom.all': 'Tous',
    'pg.showroom.active': 'Actifs',
    'pg.showroom.hidden': 'Masqués',
    'pg.showroom.noProductsYet': 'Aucun produit pour le moment',
    'pg.showroom.noActiveProducts': 'Aucun produit actif',
    'pg.showroom.noHiddenProducts': 'Aucun produit masqué',
    'pg.showroom.startShowcasing': 'Commencez à présenter vos produits et services sur la place de marché.',
    'pg.showroom.addFirstProduct': 'Ajoutez votre premier produit',
    'pg.showroom.analyticsOverview': 'Aperçu des analyses',
    'pg.showroom.totalViews': 'Vues totales',
    'pg.showroom.products': 'Produits',
    'pg.showroom.rating': 'Évaluation',
    'pg.showroom.viewFullAnalytics': 'Voir toutes les analyses',
    'pg.customers.failedLoad': 'Échec du chargement des clients',
    'pg.customers.noConversation': 'Aucune conversation trouvée',
    'pg.customers.callInitiated': 'Appel lancé',
    'pg.customers.callLogged': 'Appel enregistré',
    'pg.survey.createSurvey': 'Créer un sondage',
    'pg.survey.subtitle': 'Créez des sondages attrayants pour recueillir les commentaires des clients',
    'pg.survey.multipleChoice': 'Choix multiple',
    'pg.survey.textResponse': 'Réponse textuelle',
    'pg.survey.ratingScale': 'Échelle de notation',
    'pg.survey.yesNo': 'Oui/Non',
    'pg.survey.enterQuestion': 'Veuillez saisir une question avant de l\'ajouter',
    'pg.survey.questionAdded': 'Question ajoutée',
    'pg.survey.questionAddedDesc': 'La question a été ajoutée au sondage',
    'pg.survey.missingInfo': 'Informations manquantes',
    'pg.survey.missingInfoDesc': 'Veuillez remplir tous les champs obligatoires et ajouter au moins une question',
    'pg.survey.surveyCreated': 'Sondage créé !',
    'pg.survey.surveyCreatedDesc': 'Votre sondage a été créé avec succès et est désormais disponible pour les clients',
    'pg.survey.createFailed': 'Échec de la création du sondage. Veuillez réessayer.',
    'pg.category.authNotReady': 'Authentification non prête',
    'pg.category.refreshTryAgain': 'Veuillez actualiser et réessayer.',
    'pg.category.failedLoadCategories': 'Échec du chargement des catégories de commentaires',
    'pg.category.customizationSaved': 'Personnalisation de la catégorie enregistrée avec succès',
    'pg.category.title': 'Gestion des catégories de commentaires',
    'pg.category.subtitle': 'Gérez et personnalisez les catégories de commentaires de votre entreprise',
    'pg.director.title': 'Tableau de bord du directeur',
    'pg.director.livePerf': 'Performance de l\'équipe en direct —',
    'pg.director.teamProductivity': 'Productivité de l\'équipe',
    'pg.director.workloadDistribution': 'Répartition de la charge de travail',
    'pg.director.departmentKpis': 'KPI du département',
    'pg.director.resolutionRate': 'Taux de résolution',
    'pg.director.ticketsResolved': 'Tickets résolus',
    'pg.director.thisPeriod': 'Cette période',
    'pg.director.avgFirstResponse': 'Première réponse moyenne',
    'pg.director.avgResolution': 'Résolution moyenne',
    'pg.director.dailyResVsEsc': 'Résolution vs escalade quotidienne',
    'pg.director.liveUnavailable': 'Les analyses en direct sont temporairement indisponibles. Veuillez réessayer.',
    'pg.director.workspaceNotLinked': 'Votre compte n\'est pas encore lié à un espace de travail, les analyses ne peuvent donc pas se charger. Contactez votre administrateur si cela est inattendu.',
    'pg.exec.title': 'Tableau de bord exécutif',
    'pg.exec.liveMetrics': 'Indicateurs opérationnels en direct —',
    'pg.exec.days7': '7 jours',
    'pg.exec.days30': '30 jours',
    'pg.exec.days90': '90 jours',
    'pg.exec.totalCustomers': 'Total des clients',
    'pg.exec.registeredPlatform': 'Inscrits sur la plateforme',
    'pg.exec.aiResolutionRate': 'Taux de résolution par IA',
    'pg.exec.chatAutoResolved': 'Chat résolu automatiquement',
    'pg.exec.customerCsat': 'CSAT client',
    'pg.exec.noRatingsYet': 'Aucune évaluation pour le moment',
    'pg.exec.escalationRate': 'Taux d\'escalade',
    'pg.exec.failedLoad': 'Échec du chargement des données du tableau de bord',
    'pg.it.title': 'Tableau de bord TI',
    'pg.it.tenantIntegrationOps': 'Opérations d\'intégration du locataire —',
    'pg.it.tenantScopedNotice': 'Données limitées au locataire uniquement. L\'état de l\'infrastructure de la plateforme/du système est géré par Servisfy et n\'est pas affiché ici.',
    'pg.it.connectors': 'Connecteurs',
    'pg.it.loading': 'Chargement…',
    'pg.it.failedConnectors': 'Échec du chargement des connecteurs.',
    'pg.it.noConnectors': 'Aucun connecteur configuré pour le moment.',
    'pg.it.openIntegrationHub': 'Ouvrir le hub d\'intégration',
    'pg.it.activeConfigured': '{active} actifs / {configured} configurés',
    'pg.it.enabled': 'Activé',
    'pg.it.disabled': 'Désactivé',
    'pg.it.dataVolume': 'Volume de données',
    'pg.it.conversations': 'Conversations',
    'pg.it.escalations': 'Escalades',
    'pg.it.liveTenantCounts': 'Nombre d\'enregistrements du locataire en direct (limité à la TI).',
    'pg.it.workspaceNotLinked': 'Votre compte n\'est pas encore lié à un espace de travail, les données du locataire ne peuvent donc pas se charger. Contactez votre administrateur si cela est inattendu.',
  },
  pt: {
    'pg.billing.title': 'Faturamento e assinatura',
    'pg.billing.subtitle': 'Gerencie seu plano, veja faturas e faça upgrade ou downgrade.',
    'pg.billing.currentPlan': 'Plano atual',
    'pg.billing.currentPlanDesc': 'Sua assinatura ativa e os principais limites.',
    'pg.billing.tier': 'Nível',
    'pg.billing.price': 'Preço',
    'pg.billing.brandId': 'ID da marca',
    'pg.billing.status': 'Status',
    'pg.billing.users': 'Usuários',
    'pg.billing.engagements': 'Interações / mês',
    'pg.billing.storage': 'Armazenamento',
    'pg.billing.changePlan': 'Alterar plano',
    'pg.billing.changePlanDesc': 'Escolha um novo nível — você será redirecionado para o checkout seguro da Stripe.',
    'pg.billing.current': 'Atual',
    'pg.billing.onRequest': 'Sob consulta',
    'pg.billing.contactSales': 'Falar com vendas',
    'pg.billing.switchPlan': 'Mudar para este plano',
    'pg.billing.currentPlanBtn': 'Plano atual',
    'pg.billing.redirecting': 'Redirecionando…',
    'pg.billing.managePayments': 'Gerenciar métodos de pagamento e cancelamentos',
    'pg.billing.managePaymentsDesc': 'Abra o portal seguro do cliente da Stripe para atualizar seu cartão, baixar recibos ou cancelar sua assinatura.',
    'pg.billing.openingStripe': 'Abrindo a Stripe…',
    'pg.billing.redirectingCheckout': 'Redirecionando para o checkout…',
    'pg.billing.openPortal': 'Abrir o portal do cliente da Stripe',
    'pg.billing.portalNotice': 'Ainda não há assinatura paga ativa — ao clicar, o checkout seguro da Stripe será aberto para ativar seu plano. Após o pagamento, o portal fica disponível imediatamente.',
    'pg.billing.invoiceHistory': 'Histórico de faturas',
    'pg.billing.invoiceHistoryDesc': 'Suas sessões de checkout da Stripe mais recentes.',
    'pg.billing.noInvoices': 'Ainda não há faturas.',
    'pg.billing.upgradeToStart': 'Faça upgrade para um plano pago para começar a faturar.',
    'pg.billing.date': 'Data',
    'pg.billing.amount': 'Valor',
    'pg.billing.intent': 'Finalidade',
    'pg.billing.paymentsSecure': 'Pagamentos processados com segurança pela Stripe.',
    'pg.mkt.searchPlaceholder': 'Pesquisar produtos, serviços ou empresas...',
    'pg.mkt.allCategories': 'Todas as categorias',
    'pg.mkt.location': 'Localização',
    'pg.mkt.recommended': 'Recomendado para você',
    'pg.mkt.noRecommendations': 'Ainda não há recomendações.',
    'pg.mkt.browseCategories': 'Explorar categorias',
    'pg.mkt.searchResultsFor': 'Resultados da pesquisa para "{query}"',
    'pg.mkt.allProducts': 'Todos os produtos',
    'pg.mkt.productsFound': 'produtos encontrados',
    'pg.mkt.newestFirst': 'Mais recentes primeiro',
    'pg.mkt.priceLowHigh': 'Preço: do menor ao maior',
    'pg.mkt.priceHighLow': 'Preço: do maior ao menor',
    'pg.mkt.noPriceMatch': 'Nenhum produto nesta página corresponde ao seu filtro de preço.',
    'pg.mkt.page': 'Página',
    'pg.mkt.noProductsFound': 'Nenhum produto encontrado',
    'pg.mkt.adjustSearch': 'Tente ajustar seus critérios de pesquisa ou explorar outras categorias.',
    'pg.mkt.clearFilters': 'Limpar filtros',
    'pg.mkt.productDetailsInfo': 'Detalhes e informações do produto',
    'pg.mkt.description': 'Descrição',
    'pg.mkt.price': 'Preço',
    'pg.mkt.tags': 'Tags',
    'pg.mkt.contactForPrice': 'Consultar preço',
    'pg.mkt.addToFavorites': 'Adicionar aos favoritos',
    'pg.mkt.contactBusiness': 'Contatar a empresa',
    'pg.mkt.contactBusinessSoon': 'O envio de mensagens diretamente para uma empresa pelo marketplace estará disponível em breve.',
    'pg.mkt.filterProducts': 'Filtrar produtos',
    'pg.mkt.refineSearch': 'Refine sua pesquisa com filtros avançados',
    'pg.mkt.priceRange': 'Faixa de preço',
    'pg.mkt.min': 'Mín',
    'pg.mkt.max': 'Máx',
    'pg.mkt.category': 'Categoria',
    'pg.mkt.selectCategory': 'Selecionar categoria',
    'pg.mkt.clearAll': 'Limpar tudo',
    'pg.mkt.applyFilters': 'Aplicar filtros',
    'pg.showroom.createTitle': 'Crie o showroom da sua empresa',
    'pg.showroom.createSubtitle': 'Configure sua presença no marketplace e comece a exibir seus produtos e serviços',
    'pg.showroom.basicInfo': 'Informações básicas',
    'pg.showroom.businessNameReq': 'Nome da empresa *',
    'pg.showroom.enterBusinessName': 'Digite o nome da sua empresa',
    'pg.showroom.descriptionReq': 'Descrição *',
    'pg.showroom.describeBusiness': 'Descreva sua empresa e o que você oferece',
    'pg.showroom.location': 'Localização',
    'pg.showroom.businessAddress': 'Endereço da empresa',
    'pg.showroom.enterAddress': 'Digite o endereço da sua empresa',
    'pg.showroom.locationVerified': 'Localização verificada',
    'pg.showroom.contactOptions': 'Opções de contato',
    'pg.showroom.email': 'E-mail',
    'pg.showroom.phone': 'Telefone',
    'pg.showroom.enableChat': 'Ativar suporte por chat',
    'pg.showroom.enableCalling': 'Ativar chamadas no app',
    'pg.showroom.createShowroom': 'Criar showroom',
    'pg.showroom.managerTitle': 'Gerenciador de showroom',
    'pg.showroom.managerSubtitle': 'Gerencie a presença da sua empresa no marketplace',
    'pg.showroom.editShowroom': 'Editar showroom',
    'pg.showroom.saveChanges': 'Salvar alterações',
    'pg.showroom.showroomInfo': 'Informações do showroom',
    'pg.showroom.productsServices': 'Produtos e serviços',
    'pg.showroom.addProduct': 'Adicionar produto',
    'pg.showroom.all': 'Todos',
    'pg.showroom.active': 'Ativos',
    'pg.showroom.hidden': 'Ocultos',
    'pg.showroom.noProductsYet': 'Ainda não há produtos',
    'pg.showroom.noActiveProducts': 'Nenhum produto ativo',
    'pg.showroom.noHiddenProducts': 'Nenhum produto oculto',
    'pg.showroom.startShowcasing': 'Comece a exibir seus produtos e serviços no marketplace.',
    'pg.showroom.addFirstProduct': 'Adicione seu primeiro produto',
    'pg.showroom.analyticsOverview': 'Visão geral de análises',
    'pg.showroom.totalViews': 'Visualizações totais',
    'pg.showroom.products': 'Produtos',
    'pg.showroom.rating': 'Avaliação',
    'pg.showroom.viewFullAnalytics': 'Ver análises completas',
    'pg.customers.failedLoad': 'Falha ao carregar clientes',
    'pg.customers.noConversation': 'Nenhuma conversa encontrada',
    'pg.customers.callInitiated': 'Chamada iniciada',
    'pg.customers.callLogged': 'Chamada registrada',
    'pg.survey.createSurvey': 'Criar pesquisa',
    'pg.survey.subtitle': 'Crie pesquisas envolventes para coletar feedback dos clientes',
    'pg.survey.multipleChoice': 'Múltipla escolha',
    'pg.survey.textResponse': 'Resposta de texto',
    'pg.survey.ratingScale': 'Escala de avaliação',
    'pg.survey.yesNo': 'Sim/Não',
    'pg.survey.enterQuestion': 'Digite uma pergunta antes de adicionar',
    'pg.survey.questionAdded': 'Pergunta adicionada',
    'pg.survey.questionAddedDesc': 'A pergunta foi adicionada à pesquisa',
    'pg.survey.missingInfo': 'Informações faltando',
    'pg.survey.missingInfoDesc': 'Preencha todos os campos obrigatórios e adicione pelo menos uma pergunta',
    'pg.survey.surveyCreated': 'Pesquisa criada!',
    'pg.survey.surveyCreatedDesc': 'Sua pesquisa foi criada com sucesso e já está disponível para os clientes',
    'pg.survey.createFailed': 'Falha ao criar a pesquisa. Tente novamente.',
    'pg.category.authNotReady': 'Autenticação não está pronta',
    'pg.category.refreshTryAgain': 'Atualize a página e tente novamente.',
    'pg.category.failedLoadCategories': 'Falha ao carregar categorias de feedback',
    'pg.category.customizationSaved': 'Personalização de categoria salva com sucesso',
    'pg.category.title': 'Gerenciamento de categorias de feedback',
    'pg.category.subtitle': 'Gerencie e personalize as categorias de feedback da sua empresa',
    'pg.director.title': 'Painel do diretor',
    'pg.director.livePerf': 'Desempenho da equipe ao vivo —',
    'pg.director.teamProductivity': 'Produtividade da equipe',
    'pg.director.workloadDistribution': 'Distribuição da carga de trabalho',
    'pg.director.departmentKpis': 'KPIs do departamento',
    'pg.director.resolutionRate': 'Taxa de resolução',
    'pg.director.ticketsResolved': 'Tickets resolvidos',
    'pg.director.thisPeriod': 'Este período',
    'pg.director.avgFirstResponse': 'Primeira resposta média',
    'pg.director.avgResolution': 'Resolução média',
    'pg.director.dailyResVsEsc': 'Resolução vs. escalação diária',
    'pg.director.liveUnavailable': 'As análises ao vivo estão temporariamente indisponíveis. Tente novamente.',
    'pg.director.workspaceNotLinked': 'Sua conta ainda não está vinculada a um espaço de trabalho, portanto as análises não podem ser carregadas. Contate seu administrador se isso for inesperado.',
    'pg.exec.title': 'Painel executivo',
    'pg.exec.liveMetrics': 'Métricas operacionais ao vivo —',
    'pg.exec.days7': '7 dias',
    'pg.exec.days30': '30 dias',
    'pg.exec.days90': '90 dias',
    'pg.exec.totalCustomers': 'Total de clientes',
    'pg.exec.registeredPlatform': 'Registrados na plataforma',
    'pg.exec.aiResolutionRate': 'Taxa de resolução por IA',
    'pg.exec.chatAutoResolved': 'Chat resolvido automaticamente',
    'pg.exec.customerCsat': 'CSAT do cliente',
    'pg.exec.noRatingsYet': 'Ainda não há avaliações',
    'pg.exec.escalationRate': 'Taxa de escalação',
    'pg.exec.failedLoad': 'Falha ao carregar os dados do painel',
    'pg.it.title': 'Painel de TI',
    'pg.it.tenantIntegrationOps': 'Operações de integração do inquilino —',
    'pg.it.tenantScopedNotice': 'Apenas dados do inquilino. A integridade da infraestrutura da plataforma/sistema é gerenciada pela Servisfy e não é exibida aqui.',
    'pg.it.connectors': 'Conectores',
    'pg.it.loading': 'Carregando…',
    'pg.it.failedConnectors': 'Falha ao carregar conectores.',
    'pg.it.noConnectors': 'Ainda não há conectores configurados.',
    'pg.it.openIntegrationHub': 'Abrir o hub de integração',
    'pg.it.activeConfigured': '{active} ativos / {configured} configurados',
    'pg.it.enabled': 'Ativado',
    'pg.it.disabled': 'Desativado',
    'pg.it.dataVolume': 'Volume de dados',
    'pg.it.conversations': 'Conversas',
    'pg.it.escalations': 'Escalações',
    'pg.it.liveTenantCounts': 'Contagens de registros do inquilino ao vivo (escopo de TI).',
    'pg.it.workspaceNotLinked': 'Sua conta ainda não está vinculada a um espaço de trabalho, portanto os dados do inquilino não podem ser carregados. Contate seu administrador se isso for inesperado.',
  },
  de: {
    'pg.billing.title': 'Abrechnung & Abonnement',
    'pg.billing.subtitle': 'Verwalten Sie Ihren Tarif, sehen Sie Rechnungen ein und führen Sie ein Upgrade oder Downgrade durch.',
    'pg.billing.currentPlan': 'Aktueller Tarif',
    'pg.billing.currentPlanDesc': 'Ihr aktives Abonnement und die wichtigsten Limits.',
    'pg.billing.tier': 'Stufe',
    'pg.billing.price': 'Preis',
    'pg.billing.brandId': 'Marken-ID',
    'pg.billing.status': 'Status',
    'pg.billing.users': 'Benutzer',
    'pg.billing.engagements': 'Interaktionen / Monat',
    'pg.billing.storage': 'Speicher',
    'pg.billing.changePlan': 'Tarif ändern',
    'pg.billing.changePlanDesc': 'Wählen Sie eine neue Stufe — Sie werden zum sicheren Stripe-Checkout weitergeleitet.',
    'pg.billing.current': 'Aktuell',
    'pg.billing.onRequest': 'Auf Anfrage',
    'pg.billing.contactSales': 'Vertrieb kontaktieren',
    'pg.billing.switchPlan': 'Zu diesem Tarif wechseln',
    'pg.billing.currentPlanBtn': 'Aktueller Tarif',
    'pg.billing.redirecting': 'Weiterleitung…',
    'pg.billing.managePayments': 'Zahlungsmethoden & Kündigungen verwalten',
    'pg.billing.managePaymentsDesc': 'Öffnen Sie das sichere Kundenportal von Stripe, um Ihre Karte zu aktualisieren, Belege herunterzuladen oder Ihr Abonnement zu kündigen.',
    'pg.billing.openingStripe': 'Stripe wird geöffnet…',
    'pg.billing.redirectingCheckout': 'Weiterleitung zum Checkout…',
    'pg.billing.openPortal': 'Stripe-Kundenportal öffnen',
    'pg.billing.portalNotice': 'Noch kein aktives kostenpflichtiges Abonnement — mit einem Klick öffnet sich der sichere Stripe-Checkout, um Ihren Tarif zu aktivieren. Nach der Zahlung ist das Portal sofort verfügbar.',
    'pg.billing.invoiceHistory': 'Rechnungsverlauf',
    'pg.billing.invoiceHistoryDesc': 'Ihre letzten Stripe-Checkout-Sitzungen.',
    'pg.billing.noInvoices': 'Noch keine Rechnungen.',
    'pg.billing.upgradeToStart': 'Führen Sie ein Upgrade auf einen kostenpflichtigen Tarif durch, um mit der Abrechnung zu beginnen.',
    'pg.billing.date': 'Datum',
    'pg.billing.amount': 'Betrag',
    'pg.billing.intent': 'Zweck',
    'pg.billing.paymentsSecure': 'Zahlungen werden sicher von Stripe verarbeitet.',
    'pg.mkt.searchPlaceholder': 'Produkte, Dienstleistungen oder Unternehmen suchen...',
    'pg.mkt.allCategories': 'Alle Kategorien',
    'pg.mkt.location': 'Standort',
    'pg.mkt.recommended': 'Für Sie empfohlen',
    'pg.mkt.noRecommendations': 'Noch keine Empfehlungen.',
    'pg.mkt.browseCategories': 'Kategorien durchsuchen',
    'pg.mkt.searchResultsFor': 'Suchergebnisse für "{query}"',
    'pg.mkt.allProducts': 'Alle Produkte',
    'pg.mkt.productsFound': 'Produkte gefunden',
    'pg.mkt.newestFirst': 'Neueste zuerst',
    'pg.mkt.priceLowHigh': 'Preis: aufsteigend',
    'pg.mkt.priceHighLow': 'Preis: absteigend',
    'pg.mkt.noPriceMatch': 'Kein Produkt auf dieser Seite entspricht Ihrem Preisfilter.',
    'pg.mkt.page': 'Seite',
    'pg.mkt.noProductsFound': 'Keine Produkte gefunden',
    'pg.mkt.adjustSearch': 'Passen Sie Ihre Suchkriterien an oder durchsuchen Sie andere Kategorien.',
    'pg.mkt.clearFilters': 'Filter zurücksetzen',
    'pg.mkt.productDetailsInfo': 'Produktdetails und Informationen',
    'pg.mkt.description': 'Beschreibung',
    'pg.mkt.price': 'Preis',
    'pg.mkt.tags': 'Tags',
    'pg.mkt.contactForPrice': 'Preis auf Anfrage',
    'pg.mkt.addToFavorites': 'Zu Favoriten hinzufügen',
    'pg.mkt.contactBusiness': 'Unternehmen kontaktieren',
    'pg.mkt.contactBusinessSoon': 'Das direkte Nachrichten an ein Unternehmen über den Marktplatz ist bald verfügbar.',
    'pg.mkt.filterProducts': 'Produkte filtern',
    'pg.mkt.refineSearch': 'Verfeinern Sie Ihre Suche mit erweiterten Filtern',
    'pg.mkt.priceRange': 'Preisspanne',
    'pg.mkt.min': 'Min',
    'pg.mkt.max': 'Max',
    'pg.mkt.category': 'Kategorie',
    'pg.mkt.selectCategory': 'Kategorie auswählen',
    'pg.mkt.clearAll': 'Alles zurücksetzen',
    'pg.mkt.applyFilters': 'Filter anwenden',
    'pg.showroom.createTitle': 'Erstellen Sie Ihren Firmen-Showroom',
    'pg.showroom.createSubtitle': 'Richten Sie Ihre Präsenz auf dem Marktplatz ein und präsentieren Sie Ihre Produkte und Dienstleistungen',
    'pg.showroom.basicInfo': 'Grundlegende Informationen',
    'pg.showroom.businessNameReq': 'Firmenname *',
    'pg.showroom.enterBusinessName': 'Geben Sie Ihren Firmennamen ein',
    'pg.showroom.descriptionReq': 'Beschreibung *',
    'pg.showroom.describeBusiness': 'Beschreiben Sie Ihr Unternehmen und Ihr Angebot',
    'pg.showroom.location': 'Standort',
    'pg.showroom.businessAddress': 'Firmenadresse',
    'pg.showroom.enterAddress': 'Geben Sie Ihre Firmenadresse ein',
    'pg.showroom.locationVerified': 'Standort verifiziert',
    'pg.showroom.contactOptions': 'Kontaktoptionen',
    'pg.showroom.email': 'E-Mail',
    'pg.showroom.phone': 'Telefon',
    'pg.showroom.enableChat': 'Chat-Support aktivieren',
    'pg.showroom.enableCalling': 'In-App-Anrufe aktivieren',
    'pg.showroom.createShowroom': 'Showroom erstellen',
    'pg.showroom.managerTitle': 'Showroom-Manager',
    'pg.showroom.managerSubtitle': 'Verwalten Sie die Präsenz Ihres Unternehmens auf dem Marktplatz',
    'pg.showroom.editShowroom': 'Showroom bearbeiten',
    'pg.showroom.saveChanges': 'Änderungen speichern',
    'pg.showroom.showroomInfo': 'Showroom-Informationen',
    'pg.showroom.productsServices': 'Produkte & Dienstleistungen',
    'pg.showroom.addProduct': 'Produkt hinzufügen',
    'pg.showroom.all': 'Alle',
    'pg.showroom.active': 'Aktiv',
    'pg.showroom.hidden': 'Ausgeblendet',
    'pg.showroom.noProductsYet': 'Noch keine Produkte',
    'pg.showroom.noActiveProducts': 'Keine aktiven Produkte',
    'pg.showroom.noHiddenProducts': 'Keine ausgeblendeten Produkte',
    'pg.showroom.startShowcasing': 'Präsentieren Sie Ihre Produkte und Dienstleistungen auf dem Marktplatz.',
    'pg.showroom.addFirstProduct': 'Fügen Sie Ihr erstes Produkt hinzu',
    'pg.showroom.analyticsOverview': 'Analyse-Übersicht',
    'pg.showroom.totalViews': 'Aufrufe gesamt',
    'pg.showroom.products': 'Produkte',
    'pg.showroom.rating': 'Bewertung',
    'pg.showroom.viewFullAnalytics': 'Vollständige Analysen anzeigen',
    'pg.customers.failedLoad': 'Kunden konnten nicht geladen werden',
    'pg.customers.noConversation': 'Keine Konversation gefunden',
    'pg.customers.callInitiated': 'Anruf gestartet',
    'pg.customers.callLogged': 'Anruf protokolliert',
    'pg.survey.createSurvey': 'Umfrage erstellen',
    'pg.survey.subtitle': 'Erstellen Sie ansprechende Umfragen, um Kundenfeedback zu sammeln',
    'pg.survey.multipleChoice': 'Multiple Choice',
    'pg.survey.textResponse': 'Textantwort',
    'pg.survey.ratingScale': 'Bewertungsskala',
    'pg.survey.yesNo': 'Ja/Nein',
    'pg.survey.enterQuestion': 'Bitte geben Sie eine Frage ein, bevor Sie sie hinzufügen',
    'pg.survey.questionAdded': 'Frage hinzugefügt',
    'pg.survey.questionAddedDesc': 'Die Frage wurde zur Umfrage hinzugefügt',
    'pg.survey.missingInfo': 'Fehlende Informationen',
    'pg.survey.missingInfoDesc': 'Bitte füllen Sie alle Pflichtfelder aus und fügen Sie mindestens eine Frage hinzu',
    'pg.survey.surveyCreated': 'Umfrage erstellt!',
    'pg.survey.surveyCreatedDesc': 'Ihre Umfrage wurde erfolgreich erstellt und ist nun für Kunden verfügbar',
    'pg.survey.createFailed': 'Umfrage konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    'pg.category.authNotReady': 'Authentifizierung nicht bereit',
    'pg.category.refreshTryAgain': 'Bitte aktualisieren Sie und versuchen Sie es erneut.',
    'pg.category.failedLoadCategories': 'Feedback-Kategorien konnten nicht geladen werden',
    'pg.category.customizationSaved': 'Kategorie-Anpassung erfolgreich gespeichert',
    'pg.category.title': 'Verwaltung der Feedback-Kategorien',
    'pg.category.subtitle': 'Verwalten und passen Sie die Feedback-Kategorien für Ihr Unternehmen an',
    'pg.director.title': 'Direktor-Dashboard',
    'pg.director.livePerf': 'Team-Leistung live —',
    'pg.director.teamProductivity': 'Team-Produktivität',
    'pg.director.workloadDistribution': 'Verteilung der Arbeitslast',
    'pg.director.departmentKpis': 'Abteilungs-KPIs',
    'pg.director.resolutionRate': 'Lösungsrate',
    'pg.director.ticketsResolved': 'Gelöste Tickets',
    'pg.director.thisPeriod': 'Dieser Zeitraum',
    'pg.director.avgFirstResponse': 'Durchschnittliche Erstreaktion',
    'pg.director.avgResolution': 'Durchschnittliche Lösung',
    'pg.director.dailyResVsEsc': 'Tägliche Lösung vs. Eskalation',
    'pg.director.liveUnavailable': 'Live-Analysen sind vorübergehend nicht verfügbar. Bitte versuchen Sie es erneut.',
    'pg.director.workspaceNotLinked': 'Ihr Konto ist noch nicht mit einem Arbeitsbereich verknüpft, daher können keine Analysen geladen werden. Wenden Sie sich an Ihren Administrator, falls dies unerwartet ist.',
    'pg.exec.title': 'Führungs-Dashboard',
    'pg.exec.liveMetrics': 'Betriebskennzahlen live —',
    'pg.exec.days7': '7 Tage',
    'pg.exec.days30': '30 Tage',
    'pg.exec.days90': '90 Tage',
    'pg.exec.totalCustomers': 'Kunden gesamt',
    'pg.exec.registeredPlatform': 'Auf der Plattform registriert',
    'pg.exec.aiResolutionRate': 'KI-Lösungsrate',
    'pg.exec.chatAutoResolved': 'Chat automatisch gelöst',
    'pg.exec.customerCsat': 'Kunden-CSAT',
    'pg.exec.noRatingsYet': 'Noch keine Bewertungen',
    'pg.exec.escalationRate': 'Eskalationsrate',
    'pg.exec.failedLoad': 'Dashboard-Daten konnten nicht geladen werden',
    'pg.it.title': 'IT-Dashboard',
    'pg.it.tenantIntegrationOps': 'Integrationsvorgänge des Mandanten —',
    'pg.it.tenantScopedNotice': 'Nur mandantenbezogene Daten. Der Zustand der Plattform-/Systeminfrastruktur wird von Servisfy verwaltet und hier nicht angezeigt.',
    'pg.it.connectors': 'Konnektoren',
    'pg.it.loading': 'Wird geladen…',
    'pg.it.failedConnectors': 'Konnektoren konnten nicht geladen werden.',
    'pg.it.noConnectors': 'Noch keine Konnektoren konfiguriert.',
    'pg.it.openIntegrationHub': 'Integrations-Hub öffnen',
    'pg.it.activeConfigured': '{active} aktiv / {configured} konfiguriert',
    'pg.it.enabled': 'Aktiviert',
    'pg.it.disabled': 'Deaktiviert',
    'pg.it.dataVolume': 'Datenvolumen',
    'pg.it.conversations': 'Konversationen',
    'pg.it.escalations': 'Eskalationen',
    'pg.it.liveTenantCounts': 'Live-Datensatzanzahl des Mandanten (IT-bezogen).',
    'pg.it.workspaceNotLinked': 'Ihr Konto ist noch nicht mit einem Arbeitsbereich verknüpft, daher können keine Mandantendaten geladen werden. Wenden Sie sich an Ihren Administrator, falls dies unerwartet ist.',
  },
  it: {
    'pg.billing.title': 'Fatturazione e abbonamento',
    'pg.billing.subtitle': 'Gestisci il tuo piano, visualizza le fatture ed effettua un upgrade o un downgrade.',
    'pg.billing.currentPlan': 'Piano attuale',
    'pg.billing.currentPlanDesc': 'Il tuo abbonamento attivo e i limiti principali.',
    'pg.billing.tier': 'Livello',
    'pg.billing.price': 'Prezzo',
    'pg.billing.brandId': 'ID marchio',
    'pg.billing.status': 'Stato',
    'pg.billing.users': 'Utenti',
    'pg.billing.engagements': 'Interazioni / mese',
    'pg.billing.storage': 'Archiviazione',
    'pg.billing.changePlan': 'Cambia piano',
    'pg.billing.changePlanDesc': 'Scegli un nuovo livello — verrai reindirizzato al checkout sicuro di Stripe.',
    'pg.billing.current': 'Attuale',
    'pg.billing.onRequest': 'Su richiesta',
    'pg.billing.contactSales': 'Contatta le vendite',
    'pg.billing.switchPlan': 'Passa a questo piano',
    'pg.billing.currentPlanBtn': 'Piano attuale',
    'pg.billing.redirecting': 'Reindirizzamento…',
    'pg.billing.managePayments': 'Gestisci metodi di pagamento e cancellazioni',
    'pg.billing.managePaymentsDesc': 'Apri il portale clienti sicuro di Stripe per aggiornare la tua carta, scaricare ricevute o annullare il tuo abbonamento.',
    'pg.billing.openingStripe': 'Apertura di Stripe…',
    'pg.billing.redirectingCheckout': 'Reindirizzamento al checkout…',
    'pg.billing.openPortal': 'Apri il portale clienti di Stripe',
    'pg.billing.portalNotice': 'Nessun abbonamento a pagamento attivo — cliccando si aprirà il checkout sicuro di Stripe per attivare il tuo piano. Dopo il pagamento, il portale è immediatamente disponibile.',
    'pg.billing.invoiceHistory': 'Cronologia fatture',
    'pg.billing.invoiceHistoryDesc': 'Le tue sessioni di checkout Stripe più recenti.',
    'pg.billing.noInvoices': 'Ancora nessuna fattura.',
    'pg.billing.upgradeToStart': 'Passa a un piano a pagamento per iniziare la fatturazione.',
    'pg.billing.date': 'Data',
    'pg.billing.amount': 'Importo',
    'pg.billing.intent': 'Scopo',
    'pg.billing.paymentsSecure': 'Pagamenti elaborati in modo sicuro da Stripe.',
    'pg.mkt.searchPlaceholder': 'Cerca prodotti, servizi o attività...',
    'pg.mkt.allCategories': 'Tutte le categorie',
    'pg.mkt.location': 'Posizione',
    'pg.mkt.recommended': 'Consigliati per te',
    'pg.mkt.noRecommendations': 'Ancora nessun consiglio.',
    'pg.mkt.browseCategories': 'Sfoglia le categorie',
    'pg.mkt.searchResultsFor': 'Risultati di ricerca per "{query}"',
    'pg.mkt.allProducts': 'Tutti i prodotti',
    'pg.mkt.productsFound': 'prodotti trovati',
    'pg.mkt.newestFirst': 'Più recenti prima',
    'pg.mkt.priceLowHigh': 'Prezzo: dal più basso al più alto',
    'pg.mkt.priceHighLow': 'Prezzo: dal più alto al più basso',
    'pg.mkt.noPriceMatch': 'Nessun prodotto in questa pagina corrisponde al tuo filtro di prezzo.',
    'pg.mkt.page': 'Pagina',
    'pg.mkt.noProductsFound': 'Nessun prodotto trovato',
    'pg.mkt.adjustSearch': 'Prova a modificare i criteri di ricerca o a sfogliare altre categorie.',
    'pg.mkt.clearFilters': 'Cancella filtri',
    'pg.mkt.productDetailsInfo': 'Dettagli e informazioni sul prodotto',
    'pg.mkt.description': 'Descrizione',
    'pg.mkt.price': 'Prezzo',
    'pg.mkt.tags': 'Tag',
    'pg.mkt.contactForPrice': 'Prezzo su richiesta',
    'pg.mkt.addToFavorites': 'Aggiungi ai preferiti',
    'pg.mkt.contactBusiness': 'Contatta l\'attività',
    'pg.mkt.contactBusinessSoon': 'La messaggistica diretta con un\'attività dal marketplace sarà presto disponibile.',
    'pg.mkt.filterProducts': 'Filtra prodotti',
    'pg.mkt.refineSearch': 'Affina la tua ricerca con filtri avanzati',
    'pg.mkt.priceRange': 'Fascia di prezzo',
    'pg.mkt.min': 'Min',
    'pg.mkt.max': 'Max',
    'pg.mkt.category': 'Categoria',
    'pg.mkt.selectCategory': 'Seleziona categoria',
    'pg.mkt.clearAll': 'Cancella tutto',
    'pg.mkt.applyFilters': 'Applica filtri',
    'pg.showroom.createTitle': 'Crea lo showroom della tua attività',
    'pg.showroom.createSubtitle': 'Configura la tua presenza sul marketplace e inizia a mostrare i tuoi prodotti e servizi',
    'pg.showroom.basicInfo': 'Informazioni di base',
    'pg.showroom.businessNameReq': 'Nome dell\'attività *',
    'pg.showroom.enterBusinessName': 'Inserisci il nome della tua attività',
    'pg.showroom.descriptionReq': 'Descrizione *',
    'pg.showroom.describeBusiness': 'Descrivi la tua attività e ciò che offri',
    'pg.showroom.location': 'Posizione',
    'pg.showroom.businessAddress': 'Indirizzo dell\'attività',
    'pg.showroom.enterAddress': 'Inserisci l\'indirizzo della tua attività',
    'pg.showroom.locationVerified': 'Posizione verificata',
    'pg.showroom.contactOptions': 'Opzioni di contatto',
    'pg.showroom.email': 'E-mail',
    'pg.showroom.phone': 'Telefono',
    'pg.showroom.enableChat': 'Abilita l\'assistenza via chat',
    'pg.showroom.enableCalling': 'Abilita le chiamate in-app',
    'pg.showroom.createShowroom': 'Crea showroom',
    'pg.showroom.managerTitle': 'Gestore showroom',
    'pg.showroom.managerSubtitle': 'Gestisci la presenza della tua attività sul marketplace',
    'pg.showroom.editShowroom': 'Modifica showroom',
    'pg.showroom.saveChanges': 'Salva modifiche',
    'pg.showroom.showroomInfo': 'Informazioni sullo showroom',
    'pg.showroom.productsServices': 'Prodotti e servizi',
    'pg.showroom.addProduct': 'Aggiungi prodotto',
    'pg.showroom.all': 'Tutti',
    'pg.showroom.active': 'Attivi',
    'pg.showroom.hidden': 'Nascosti',
    'pg.showroom.noProductsYet': 'Ancora nessun prodotto',
    'pg.showroom.noActiveProducts': 'Nessun prodotto attivo',
    'pg.showroom.noHiddenProducts': 'Nessun prodotto nascosto',
    'pg.showroom.startShowcasing': 'Inizia a mostrare i tuoi prodotti e servizi sul marketplace.',
    'pg.showroom.addFirstProduct': 'Aggiungi il tuo primo prodotto',
    'pg.showroom.analyticsOverview': 'Panoramica delle analisi',
    'pg.showroom.totalViews': 'Visualizzazioni totali',
    'pg.showroom.products': 'Prodotti',
    'pg.showroom.rating': 'Valutazione',
    'pg.showroom.viewFullAnalytics': 'Visualizza analisi complete',
    'pg.customers.failedLoad': 'Impossibile caricare i clienti',
    'pg.customers.noConversation': 'Nessuna conversazione trovata',
    'pg.customers.callInitiated': 'Chiamata avviata',
    'pg.customers.callLogged': 'Chiamata registrata',
    'pg.survey.createSurvey': 'Crea sondaggio',
    'pg.survey.subtitle': 'Crea sondaggi coinvolgenti per raccogliere il feedback dei clienti',
    'pg.survey.multipleChoice': 'Scelta multipla',
    'pg.survey.textResponse': 'Risposta testuale',
    'pg.survey.ratingScale': 'Scala di valutazione',
    'pg.survey.yesNo': 'Sì/No',
    'pg.survey.enterQuestion': 'Inserisci una domanda prima di aggiungerla',
    'pg.survey.questionAdded': 'Domanda aggiunta',
    'pg.survey.questionAddedDesc': 'La domanda è stata aggiunta al sondaggio',
    'pg.survey.missingInfo': 'Informazioni mancanti',
    'pg.survey.missingInfoDesc': 'Compila tutti i campi obbligatori e aggiungi almeno una domanda',
    'pg.survey.surveyCreated': 'Sondaggio creato!',
    'pg.survey.surveyCreatedDesc': 'Il tuo sondaggio è stato creato con successo ed è ora disponibile per i clienti',
    'pg.survey.createFailed': 'Impossibile creare il sondaggio. Riprova.',
    'pg.category.authNotReady': 'Autenticazione non pronta',
    'pg.category.refreshTryAgain': 'Aggiorna la pagina e riprova.',
    'pg.category.failedLoadCategories': 'Impossibile caricare le categorie di feedback',
    'pg.category.customizationSaved': 'Personalizzazione della categoria salvata con successo',
    'pg.category.title': 'Gestione delle categorie di feedback',
    'pg.category.subtitle': 'Gestisci e personalizza le categorie di feedback per la tua attività',
    'pg.director.title': 'Dashboard del direttore',
    'pg.director.livePerf': 'Prestazioni del team in tempo reale —',
    'pg.director.teamProductivity': 'Produttività del team',
    'pg.director.workloadDistribution': 'Distribuzione del carico di lavoro',
    'pg.director.departmentKpis': 'KPI del reparto',
    'pg.director.resolutionRate': 'Tasso di risoluzione',
    'pg.director.ticketsResolved': 'Ticket risolti',
    'pg.director.thisPeriod': 'Questo periodo',
    'pg.director.avgFirstResponse': 'Prima risposta media',
    'pg.director.avgResolution': 'Risoluzione media',
    'pg.director.dailyResVsEsc': 'Risoluzione vs escalation giornaliera',
    'pg.director.liveUnavailable': 'Le analisi in tempo reale sono temporaneamente non disponibili. Riprova.',
    'pg.director.workspaceNotLinked': 'Il tuo account non è ancora collegato a un\'area di lavoro, quindi le analisi non possono essere caricate. Contatta il tuo amministratore se è inaspettato.',
    'pg.exec.title': 'Dashboard esecutiva',
    'pg.exec.liveMetrics': 'Metriche operative in tempo reale —',
    'pg.exec.days7': '7 giorni',
    'pg.exec.days30': '30 giorni',
    'pg.exec.days90': '90 giorni',
    'pg.exec.totalCustomers': 'Clienti totali',
    'pg.exec.registeredPlatform': 'Registrati nella piattaforma',
    'pg.exec.aiResolutionRate': 'Tasso di risoluzione IA',
    'pg.exec.chatAutoResolved': 'Chat risolta automaticamente',
    'pg.exec.customerCsat': 'CSAT del cliente',
    'pg.exec.noRatingsYet': 'Ancora nessuna valutazione',
    'pg.exec.escalationRate': 'Tasso di escalation',
    'pg.exec.failedLoad': 'Impossibile caricare i dati della dashboard',
    'pg.it.title': 'Dashboard IT',
    'pg.it.tenantIntegrationOps': 'Operazioni di integrazione del tenant —',
    'pg.it.tenantScopedNotice': 'Solo dati del tenant. Lo stato dell\'infrastruttura della piattaforma/sistema è gestito da Servisfy e non è mostrato qui.',
    'pg.it.connectors': 'Connettori',
    'pg.it.loading': 'Caricamento…',
    'pg.it.failedConnectors': 'Impossibile caricare i connettori.',
    'pg.it.noConnectors': 'Ancora nessun connettore configurato.',
    'pg.it.openIntegrationHub': 'Apri l\'hub di integrazione',
    'pg.it.activeConfigured': '{active} attivi / {configured} configurati',
    'pg.it.enabled': 'Abilitato',
    'pg.it.disabled': 'Disabilitato',
    'pg.it.dataVolume': 'Volume di dati',
    'pg.it.conversations': 'Conversazioni',
    'pg.it.escalations': 'Escalation',
    'pg.it.liveTenantCounts': 'Conteggi dei record del tenant in tempo reale (ambito IT).',
    'pg.it.workspaceNotLinked': 'Il tuo account non è ancora collegato a un\'area di lavoro, quindi i dati del tenant non possono essere caricati. Contatta il tuo amministratore se è inaspettato.',
  },
  ja: {
    'pg.billing.title': '請求とサブスクリプション',
    'pg.billing.subtitle': 'プランの管理、請求書の確認、アップグレードまたはダウングレードを行います。',
    'pg.billing.currentPlan': '現在のプラン',
    'pg.billing.currentPlanDesc': '有効なサブスクリプションと主な制限。',
    'pg.billing.tier': 'ティア',
    'pg.billing.price': '料金',
    'pg.billing.brandId': 'ブランドID',
    'pg.billing.status': 'ステータス',
    'pg.billing.users': 'ユーザー',
    'pg.billing.engagements': 'エンゲージメント / 月',
    'pg.billing.storage': 'ストレージ',
    'pg.billing.changePlan': 'プランを変更',
    'pg.billing.changePlanDesc': '新しいティアを選択してください — 安全なStripeチェックアウトにリダイレクトされます。',
    'pg.billing.current': '現在',
    'pg.billing.onRequest': 'お問い合わせください',
    'pg.billing.contactSales': '営業に問い合わせる',
    'pg.billing.switchPlan': 'このプランに切り替える',
    'pg.billing.currentPlanBtn': '現在のプラン',
    'pg.billing.redirecting': 'リダイレクト中…',
    'pg.billing.managePayments': '支払い方法とキャンセルの管理',
    'pg.billing.managePaymentsDesc': 'Stripeの安全なカスタマーポータルを開いて、カードの更新、領収書のダウンロード、サブスクリプションのキャンセルを行います。',
    'pg.billing.openingStripe': 'Stripeを開いています…',
    'pg.billing.redirectingCheckout': 'チェックアウトにリダイレクト中…',
    'pg.billing.openPortal': 'Stripeカスタマーポータルを開く',
    'pg.billing.portalNotice': 'まだ有効な有料サブスクリプションがありません — クリックすると、安全なStripeチェックアウトが開き、プランを有効化できます。支払い後、ポータルはすぐに利用可能になります。',
    'pg.billing.invoiceHistory': '請求書履歴',
    'pg.billing.invoiceHistoryDesc': '最近のStripeチェックアウトセッション。',
    'pg.billing.noInvoices': 'まだ請求書はありません。',
    'pg.billing.upgradeToStart': '請求を開始するには有料プランにアップグレードしてください。',
    'pg.billing.date': '日付',
    'pg.billing.amount': '金額',
    'pg.billing.intent': '目的',
    'pg.billing.paymentsSecure': '支払いはStripeによって安全に処理されます。',
    'pg.mkt.searchPlaceholder': '製品、サービス、ビジネスを検索...',
    'pg.mkt.allCategories': 'すべてのカテゴリー',
    'pg.mkt.location': '所在地',
    'pg.mkt.recommended': 'おすすめ',
    'pg.mkt.noRecommendations': 'まだおすすめはありません。',
    'pg.mkt.browseCategories': 'カテゴリーを閲覧',
    'pg.mkt.searchResultsFor': '「{query}」の検索結果',
    'pg.mkt.allProducts': 'すべての製品',
    'pg.mkt.productsFound': '件の製品が見つかりました',
    'pg.mkt.newestFirst': '新着順',
    'pg.mkt.priceLowHigh': '価格: 安い順',
    'pg.mkt.priceHighLow': '価格: 高い順',
    'pg.mkt.noPriceMatch': 'このページに価格フィルターに一致する製品はありません。',
    'pg.mkt.page': 'ページ',
    'pg.mkt.noProductsFound': '製品が見つかりません',
    'pg.mkt.adjustSearch': '検索条件を調整するか、別のカテゴリーを閲覧してください。',
    'pg.mkt.clearFilters': 'フィルターをクリア',
    'pg.mkt.productDetailsInfo': '製品の詳細と情報',
    'pg.mkt.description': '説明',
    'pg.mkt.price': '価格',
    'pg.mkt.tags': 'タグ',
    'pg.mkt.contactForPrice': '価格はお問い合わせください',
    'pg.mkt.addToFavorites': 'お気に入りに追加',
    'pg.mkt.contactBusiness': 'ビジネスに問い合わせる',
    'pg.mkt.contactBusinessSoon': 'マーケットプレイスからビジネスへの直接メッセージ機能は近日公開予定です。',
    'pg.mkt.filterProducts': '製品をフィルター',
    'pg.mkt.refineSearch': '詳細フィルターで検索を絞り込む',
    'pg.mkt.priceRange': '価格帯',
    'pg.mkt.min': '最小',
    'pg.mkt.max': '最大',
    'pg.mkt.category': 'カテゴリー',
    'pg.mkt.selectCategory': 'カテゴリーを選択',
    'pg.mkt.clearAll': 'すべてクリア',
    'pg.mkt.applyFilters': 'フィルターを適用',
    'pg.showroom.createTitle': 'ビジネスショールームを作成',
    'pg.showroom.createSubtitle': 'マーケットプレイスでの存在感を設定し、製品やサービスの紹介を始めましょう',
    'pg.showroom.basicInfo': '基本情報',
    'pg.showroom.businessNameReq': 'ビジネス名 *',
    'pg.showroom.enterBusinessName': 'ビジネス名を入力',
    'pg.showroom.descriptionReq': '説明 *',
    'pg.showroom.describeBusiness': 'ビジネスと提供内容を説明してください',
    'pg.showroom.location': '所在地',
    'pg.showroom.businessAddress': 'ビジネス住所',
    'pg.showroom.enterAddress': 'ビジネス住所を入力',
    'pg.showroom.locationVerified': '所在地が確認されました',
    'pg.showroom.contactOptions': '連絡オプション',
    'pg.showroom.email': 'メール',
    'pg.showroom.phone': '電話',
    'pg.showroom.enableChat': 'チャットサポートを有効にする',
    'pg.showroom.enableCalling': 'アプリ内通話を有効にする',
    'pg.showroom.createShowroom': 'ショールームを作成',
    'pg.showroom.managerTitle': 'ショールームマネージャー',
    'pg.showroom.managerSubtitle': 'マーケットプレイスでのビジネスの存在感を管理',
    'pg.showroom.editShowroom': 'ショールームを編集',
    'pg.showroom.saveChanges': '変更を保存',
    'pg.showroom.showroomInfo': 'ショールーム情報',
    'pg.showroom.productsServices': '製品とサービス',
    'pg.showroom.addProduct': '製品を追加',
    'pg.showroom.all': 'すべて',
    'pg.showroom.active': '公開中',
    'pg.showroom.hidden': '非表示',
    'pg.showroom.noProductsYet': 'まだ製品はありません',
    'pg.showroom.noActiveProducts': '公開中の製品はありません',
    'pg.showroom.noHiddenProducts': '非表示の製品はありません',
    'pg.showroom.startShowcasing': 'マーケットプレイスで製品やサービスの紹介を始めましょう。',
    'pg.showroom.addFirstProduct': '最初の製品を追加',
    'pg.showroom.analyticsOverview': '分析の概要',
    'pg.showroom.totalViews': '総ビュー数',
    'pg.showroom.products': '製品',
    'pg.showroom.rating': '評価',
    'pg.showroom.viewFullAnalytics': '詳細な分析を表示',
    'pg.customers.failedLoad': '顧客の読み込みに失敗しました',
    'pg.customers.noConversation': '会話が見つかりません',
    'pg.customers.callInitiated': '通話を開始しました',
    'pg.customers.callLogged': '通話を記録しました',
    'pg.survey.createSurvey': 'アンケートを作成',
    'pg.survey.subtitle': '顧客のフィードバックを収集する魅力的なアンケートを作成',
    'pg.survey.multipleChoice': '複数選択',
    'pg.survey.textResponse': 'テキスト回答',
    'pg.survey.ratingScale': '評価スケール',
    'pg.survey.yesNo': 'はい/いいえ',
    'pg.survey.enterQuestion': '追加する前に質問を入力してください',
    'pg.survey.questionAdded': '質問が追加されました',
    'pg.survey.questionAddedDesc': '質問がアンケートに追加されました',
    'pg.survey.missingInfo': '情報が不足しています',
    'pg.survey.missingInfoDesc': 'すべての必須項目を入力し、少なくとも1つの質問を追加してください',
    'pg.survey.surveyCreated': 'アンケートが作成されました！',
    'pg.survey.surveyCreatedDesc': 'アンケートが正常に作成され、顧客が利用できるようになりました',
    'pg.survey.createFailed': 'アンケートの作成に失敗しました。もう一度お試しください。',
    'pg.category.authNotReady': '認証の準備ができていません',
    'pg.category.refreshTryAgain': 'ページを更新してもう一度お試しください。',
    'pg.category.failedLoadCategories': 'フィードバックカテゴリーの読み込みに失敗しました',
    'pg.category.customizationSaved': 'カテゴリーのカスタマイズが正常に保存されました',
    'pg.category.title': 'フィードバックカテゴリー管理',
    'pg.category.subtitle': 'ビジネスのフィードバックカテゴリーを管理・カスタマイズ',
    'pg.director.title': 'ディレクターダッシュボード',
    'pg.director.livePerf': 'チームのリアルタイムパフォーマンス —',
    'pg.director.teamProductivity': 'チームの生産性',
    'pg.director.workloadDistribution': 'ワークロードの分布',
    'pg.director.departmentKpis': '部門KPI',
    'pg.director.resolutionRate': '解決率',
    'pg.director.ticketsResolved': '解決済みチケット',
    'pg.director.thisPeriod': 'この期間',
    'pg.director.avgFirstResponse': '平均初回応答',
    'pg.director.avgResolution': '平均解決時間',
    'pg.director.dailyResVsEsc': '日次の解決とエスカレーション',
    'pg.director.liveUnavailable': 'リアルタイム分析は一時的に利用できません。もう一度お試しください。',
    'pg.director.workspaceNotLinked': 'お使いのアカウントはまだワークスペースにリンクされていないため、分析を読み込めません。予期しない場合は管理者にお問い合わせください。',
    'pg.exec.title': 'エグゼクティブダッシュボード',
    'pg.exec.liveMetrics': 'リアルタイム運用指標 —',
    'pg.exec.days7': '7日間',
    'pg.exec.days30': '30日間',
    'pg.exec.days90': '90日間',
    'pg.exec.totalCustomers': '総顧客数',
    'pg.exec.registeredPlatform': 'プラットフォームに登録済み',
    'pg.exec.aiResolutionRate': 'AI解決率',
    'pg.exec.chatAutoResolved': 'チャット自動解決',
    'pg.exec.customerCsat': '顧客CSAT',
    'pg.exec.noRatingsYet': 'まだ評価はありません',
    'pg.exec.escalationRate': 'エスカレーション率',
    'pg.exec.failedLoad': 'ダッシュボードデータの読み込みに失敗しました',
    'pg.it.title': 'ITダッシュボード',
    'pg.it.tenantIntegrationOps': 'テナント統合オペレーション —',
    'pg.it.tenantScopedNotice': 'テナント範囲のデータのみ。プラットフォーム/システムインフラの状態はServisfyが管理し、ここには表示されません。',
    'pg.it.connectors': 'コネクター',
    'pg.it.loading': '読み込み中…',
    'pg.it.failedConnectors': 'コネクターの読み込みに失敗しました。',
    'pg.it.noConnectors': 'まだコネクターが設定されていません。',
    'pg.it.openIntegrationHub': '統合ハブを開く',
    'pg.it.activeConfigured': '{active} 件アクティブ / {configured} 件設定済み',
    'pg.it.enabled': '有効',
    'pg.it.disabled': '無効',
    'pg.it.dataVolume': 'データ量',
    'pg.it.conversations': '会話',
    'pg.it.escalations': 'エスカレーション',
    'pg.it.liveTenantCounts': 'テナントのリアルタイムレコード数（IT範囲）。',
    'pg.it.workspaceNotLinked': 'お使いのアカウントはまだワークスペースにリンクされていないため、テナントデータを読み込めません。予期しない場合は管理者にお問い合わせください。',
  },
  ko: {
    'pg.billing.title': '결제 및 구독',
    'pg.billing.subtitle': '플랜을 관리하고 청구서를 확인하며 업그레이드 또는 다운그레이드하세요.',
    'pg.billing.currentPlan': '현재 플랜',
    'pg.billing.currentPlanDesc': '활성 구독 및 주요 한도.',
    'pg.billing.tier': '등급',
    'pg.billing.price': '가격',
    'pg.billing.brandId': '브랜드 ID',
    'pg.billing.status': '상태',
    'pg.billing.users': '사용자',
    'pg.billing.engagements': '참여 / 월',
    'pg.billing.storage': '저장 공간',
    'pg.billing.changePlan': '플랜 변경',
    'pg.billing.changePlanDesc': '새 등급을 선택하세요 — 안전한 Stripe 결제로 이동합니다.',
    'pg.billing.current': '현재',
    'pg.billing.onRequest': '문의 필요',
    'pg.billing.contactSales': '영업팀에 문의',
    'pg.billing.switchPlan': '이 플랜으로 전환',
    'pg.billing.currentPlanBtn': '현재 플랜',
    'pg.billing.redirecting': '이동 중…',
    'pg.billing.managePayments': '결제 수단 및 취소 관리',
    'pg.billing.managePaymentsDesc': 'Stripe의 안전한 고객 포털을 열어 카드를 업데이트하고 영수증을 다운로드하거나 구독을 취소하세요.',
    'pg.billing.openingStripe': 'Stripe를 여는 중…',
    'pg.billing.redirectingCheckout': '결제로 이동 중…',
    'pg.billing.openPortal': 'Stripe 고객 포털 열기',
    'pg.billing.portalNotice': '아직 활성화된 유료 구독이 없습니다 — 클릭하면 안전한 Stripe 결제가 열려 플랜을 활성화합니다. 결제 후 포털을 즉시 사용할 수 있습니다.',
    'pg.billing.invoiceHistory': '청구서 기록',
    'pg.billing.invoiceHistoryDesc': '가장 최근의 Stripe 결제 세션.',
    'pg.billing.noInvoices': '아직 청구서가 없습니다.',
    'pg.billing.upgradeToStart': '결제를 시작하려면 유료 플랜으로 업그레이드하세요.',
    'pg.billing.date': '날짜',
    'pg.billing.amount': '금액',
    'pg.billing.intent': '목적',
    'pg.billing.paymentsSecure': '결제는 Stripe에 의해 안전하게 처리됩니다.',
    'pg.mkt.searchPlaceholder': '제품, 서비스 또는 업체 검색...',
    'pg.mkt.allCategories': '모든 카테고리',
    'pg.mkt.location': '위치',
    'pg.mkt.recommended': '추천 항목',
    'pg.mkt.noRecommendations': '아직 추천 항목이 없습니다.',
    'pg.mkt.browseCategories': '카테고리 둘러보기',
    'pg.mkt.searchResultsFor': '"{query}"에 대한 검색 결과',
    'pg.mkt.allProducts': '모든 제품',
    'pg.mkt.productsFound': '개의 제품을 찾았습니다',
    'pg.mkt.newestFirst': '최신순',
    'pg.mkt.priceLowHigh': '가격: 낮은 순',
    'pg.mkt.priceHighLow': '가격: 높은 순',
    'pg.mkt.noPriceMatch': '이 페이지에 가격 필터와 일치하는 제품이 없습니다.',
    'pg.mkt.page': '페이지',
    'pg.mkt.noProductsFound': '제품을 찾을 수 없습니다',
    'pg.mkt.adjustSearch': '검색 조건을 조정하거나 다른 카테고리를 둘러보세요.',
    'pg.mkt.clearFilters': '필터 지우기',
    'pg.mkt.productDetailsInfo': '제품 세부 정보 및 정보',
    'pg.mkt.description': '설명',
    'pg.mkt.price': '가격',
    'pg.mkt.tags': '태그',
    'pg.mkt.contactForPrice': '가격 문의',
    'pg.mkt.addToFavorites': '즐겨찾기에 추가',
    'pg.mkt.contactBusiness': '업체에 문의',
    'pg.mkt.contactBusinessSoon': '마켓플레이스에서 업체에 직접 메시지를 보내는 기능이 곧 제공됩니다.',
    'pg.mkt.filterProducts': '제품 필터',
    'pg.mkt.refineSearch': '고급 필터로 검색을 세분화하세요',
    'pg.mkt.priceRange': '가격 범위',
    'pg.mkt.min': '최소',
    'pg.mkt.max': '최대',
    'pg.mkt.category': '카테고리',
    'pg.mkt.selectCategory': '카테고리 선택',
    'pg.mkt.clearAll': '모두 지우기',
    'pg.mkt.applyFilters': '필터 적용',
    'pg.showroom.createTitle': '비즈니스 쇼룸 만들기',
    'pg.showroom.createSubtitle': '마켓플레이스에서의 입지를 설정하고 제품과 서비스를 소개하기 시작하세요',
    'pg.showroom.basicInfo': '기본 정보',
    'pg.showroom.businessNameReq': '업체 이름 *',
    'pg.showroom.enterBusinessName': '업체 이름을 입력하세요',
    'pg.showroom.descriptionReq': '설명 *',
    'pg.showroom.describeBusiness': '업체와 제공하는 내용을 설명하세요',
    'pg.showroom.location': '위치',
    'pg.showroom.businessAddress': '업체 주소',
    'pg.showroom.enterAddress': '업체 주소를 입력하세요',
    'pg.showroom.locationVerified': '위치가 확인되었습니다',
    'pg.showroom.contactOptions': '연락 옵션',
    'pg.showroom.email': '이메일',
    'pg.showroom.phone': '전화',
    'pg.showroom.enableChat': '채팅 지원 사용',
    'pg.showroom.enableCalling': '앱 내 통화 사용',
    'pg.showroom.createShowroom': '쇼룸 만들기',
    'pg.showroom.managerTitle': '쇼룸 관리자',
    'pg.showroom.managerSubtitle': '마켓플레이스에서 업체의 입지를 관리하세요',
    'pg.showroom.editShowroom': '쇼룸 편집',
    'pg.showroom.saveChanges': '변경 사항 저장',
    'pg.showroom.showroomInfo': '쇼룸 정보',
    'pg.showroom.productsServices': '제품 및 서비스',
    'pg.showroom.addProduct': '제품 추가',
    'pg.showroom.all': '전체',
    'pg.showroom.active': '활성',
    'pg.showroom.hidden': '숨김',
    'pg.showroom.noProductsYet': '아직 제품이 없습니다',
    'pg.showroom.noActiveProducts': '활성 제품이 없습니다',
    'pg.showroom.noHiddenProducts': '숨긴 제품이 없습니다',
    'pg.showroom.startShowcasing': '마켓플레이스에서 제품과 서비스를 소개하기 시작하세요.',
    'pg.showroom.addFirstProduct': '첫 번째 제품 추가',
    'pg.showroom.analyticsOverview': '분석 개요',
    'pg.showroom.totalViews': '총 조회수',
    'pg.showroom.products': '제품',
    'pg.showroom.rating': '평점',
    'pg.showroom.viewFullAnalytics': '전체 분석 보기',
    'pg.customers.failedLoad': '고객을 불러오지 못했습니다',
    'pg.customers.noConversation': '대화를 찾을 수 없습니다',
    'pg.customers.callInitiated': '통화 시작됨',
    'pg.customers.callLogged': '통화 기록됨',
    'pg.survey.createSurvey': '설문 만들기',
    'pg.survey.subtitle': '고객 피드백을 수집하기 위한 매력적인 설문을 만드세요',
    'pg.survey.multipleChoice': '객관식',
    'pg.survey.textResponse': '텍스트 응답',
    'pg.survey.ratingScale': '평가 척도',
    'pg.survey.yesNo': '예/아니요',
    'pg.survey.enterQuestion': '추가하기 전에 질문을 입력하세요',
    'pg.survey.questionAdded': '질문이 추가되었습니다',
    'pg.survey.questionAddedDesc': '질문이 설문에 추가되었습니다',
    'pg.survey.missingInfo': '정보 누락',
    'pg.survey.missingInfoDesc': '모든 필수 항목을 입력하고 질문을 하나 이상 추가하세요',
    'pg.survey.surveyCreated': '설문이 생성되었습니다!',
    'pg.survey.surveyCreatedDesc': '설문이 성공적으로 생성되어 이제 고객이 이용할 수 있습니다',
    'pg.survey.createFailed': '설문을 만들지 못했습니다. 다시 시도하세요.',
    'pg.category.authNotReady': '인증이 준비되지 않았습니다',
    'pg.category.refreshTryAgain': '새로 고침 후 다시 시도하세요.',
    'pg.category.failedLoadCategories': '피드백 카테고리를 불러오지 못했습니다',
    'pg.category.customizationSaved': '카테고리 사용자 지정이 성공적으로 저장되었습니다',
    'pg.category.title': '피드백 카테고리 관리',
    'pg.category.subtitle': '업체의 피드백 카테고리를 관리하고 사용자 지정하세요',
    'pg.director.title': '이사 대시보드',
    'pg.director.livePerf': '실시간 팀 성과 —',
    'pg.director.teamProductivity': '팀 생산성',
    'pg.director.workloadDistribution': '업무량 분포',
    'pg.director.departmentKpis': '부서 KPI',
    'pg.director.resolutionRate': '해결률',
    'pg.director.ticketsResolved': '해결된 티켓',
    'pg.director.thisPeriod': '이 기간',
    'pg.director.avgFirstResponse': '평균 첫 응답',
    'pg.director.avgResolution': '평균 해결',
    'pg.director.dailyResVsEsc': '일일 해결 대 에스컬레이션',
    'pg.director.liveUnavailable': '실시간 분석을 일시적으로 사용할 수 없습니다. 다시 시도하세요.',
    'pg.director.workspaceNotLinked': '계정이 아직 워크스페이스에 연결되지 않아 분석을 불러올 수 없습니다. 예상치 못한 경우 관리자에게 문의하세요.',
    'pg.exec.title': '임원 대시보드',
    'pg.exec.liveMetrics': '실시간 운영 지표 —',
    'pg.exec.days7': '7일',
    'pg.exec.days30': '30일',
    'pg.exec.days90': '90일',
    'pg.exec.totalCustomers': '총 고객 수',
    'pg.exec.registeredPlatform': '플랫폼에 등록됨',
    'pg.exec.aiResolutionRate': 'AI 해결률',
    'pg.exec.chatAutoResolved': '채팅 자동 해결',
    'pg.exec.customerCsat': '고객 CSAT',
    'pg.exec.noRatingsYet': '아직 평가가 없습니다',
    'pg.exec.escalationRate': '에스컬레이션 비율',
    'pg.exec.failedLoad': '대시보드 데이터를 불러오지 못했습니다',
    'pg.it.title': 'IT 대시보드',
    'pg.it.tenantIntegrationOps': '테넌트 통합 운영 —',
    'pg.it.tenantScopedNotice': '테넌트 범위 데이터만 표시됩니다. 플랫폼/시스템 인프라 상태는 Servisfy가 관리하며 여기에 표시되지 않습니다.',
    'pg.it.connectors': '커넥터',
    'pg.it.loading': '불러오는 중…',
    'pg.it.failedConnectors': '커넥터를 불러오지 못했습니다.',
    'pg.it.noConnectors': '아직 구성된 커넥터가 없습니다.',
    'pg.it.openIntegrationHub': '통합 허브 열기',
    'pg.it.activeConfigured': '{active}개 활성 / {configured}개 구성됨',
    'pg.it.enabled': '사용',
    'pg.it.disabled': '사용 안 함',
    'pg.it.dataVolume': '데이터 볼륨',
    'pg.it.conversations': '대화',
    'pg.it.escalations': '에스컬레이션',
    'pg.it.liveTenantCounts': '실시간 테넌트 레코드 수(IT 범위).',
    'pg.it.workspaceNotLinked': '계정이 아직 워크스페이스에 연결되지 않아 테넌트 데이터를 불러올 수 없습니다. 예상치 못한 경우 관리자에게 문의하세요.',
  },
  zh: {
    'pg.billing.title': '账单与订阅',
    'pg.billing.subtitle': '管理您的套餐、查看发票并升级或降级。',
    'pg.billing.currentPlan': '当前套餐',
    'pg.billing.currentPlanDesc': '您的有效订阅和主要限额。',
    'pg.billing.tier': '级别',
    'pg.billing.price': '价格',
    'pg.billing.brandId': '品牌 ID',
    'pg.billing.status': '状态',
    'pg.billing.users': '用户',
    'pg.billing.engagements': '互动 / 月',
    'pg.billing.storage': '存储',
    'pg.billing.changePlan': '更改套餐',
    'pg.billing.changePlanDesc': '选择一个新级别 — 您将被重定向到安全的 Stripe 结账页面。',
    'pg.billing.current': '当前',
    'pg.billing.onRequest': '按需报价',
    'pg.billing.contactSales': '联系销售',
    'pg.billing.switchPlan': '切换到此套餐',
    'pg.billing.currentPlanBtn': '当前套餐',
    'pg.billing.redirecting': '正在重定向…',
    'pg.billing.managePayments': '管理付款方式和取消',
    'pg.billing.managePaymentsDesc': '打开 Stripe 的安全客户门户，更新您的银行卡、下载收据或取消订阅。',
    'pg.billing.openingStripe': '正在打开 Stripe…',
    'pg.billing.redirectingCheckout': '正在重定向到结账页面…',
    'pg.billing.openPortal': '打开 Stripe 客户门户',
    'pg.billing.portalNotice': '尚无有效的付费订阅 — 点击将打开安全的 Stripe 结账页面以激活您的套餐。付款后门户会立即可用。',
    'pg.billing.invoiceHistory': '发票历史',
    'pg.billing.invoiceHistoryDesc': '您最近的 Stripe 结账会话。',
    'pg.billing.noInvoices': '暂无发票。',
    'pg.billing.upgradeToStart': '升级到付费套餐以开始计费。',
    'pg.billing.date': '日期',
    'pg.billing.amount': '金额',
    'pg.billing.intent': '用途',
    'pg.billing.paymentsSecure': '付款由 Stripe 安全处理。',
    'pg.mkt.searchPlaceholder': '搜索产品、服务或商家...',
    'pg.mkt.allCategories': '所有类别',
    'pg.mkt.location': '位置',
    'pg.mkt.recommended': '为您推荐',
    'pg.mkt.noRecommendations': '暂无推荐。',
    'pg.mkt.browseCategories': '浏览类别',
    'pg.mkt.searchResultsFor': '“{query}”的搜索结果',
    'pg.mkt.allProducts': '所有产品',
    'pg.mkt.productsFound': '个产品',
    'pg.mkt.newestFirst': '最新优先',
    'pg.mkt.priceLowHigh': '价格：从低到高',
    'pg.mkt.priceHighLow': '价格：从高到低',
    'pg.mkt.noPriceMatch': '此页面没有产品符合您的价格筛选条件。',
    'pg.mkt.page': '页',
    'pg.mkt.noProductsFound': '未找到产品',
    'pg.mkt.adjustSearch': '请尝试调整搜索条件或浏览其他类别。',
    'pg.mkt.clearFilters': '清除筛选',
    'pg.mkt.productDetailsInfo': '产品详情和信息',
    'pg.mkt.description': '描述',
    'pg.mkt.price': '价格',
    'pg.mkt.tags': '标签',
    'pg.mkt.contactForPrice': '价格请咨询',
    'pg.mkt.addToFavorites': '添加到收藏',
    'pg.mkt.contactBusiness': '联系商家',
    'pg.mkt.contactBusinessSoon': '即将支持从市场直接向商家发送消息。',
    'pg.mkt.filterProducts': '筛选产品',
    'pg.mkt.refineSearch': '使用高级筛选优化您的搜索',
    'pg.mkt.priceRange': '价格范围',
    'pg.mkt.min': '最低',
    'pg.mkt.max': '最高',
    'pg.mkt.category': '类别',
    'pg.mkt.selectCategory': '选择类别',
    'pg.mkt.clearAll': '全部清除',
    'pg.mkt.applyFilters': '应用筛选',
    'pg.showroom.createTitle': '创建您的商家展厅',
    'pg.showroom.createSubtitle': '设置您在市场中的形象，开始展示您的产品和服务',
    'pg.showroom.basicInfo': '基本信息',
    'pg.showroom.businessNameReq': '商家名称 *',
    'pg.showroom.enterBusinessName': '输入您的商家名称',
    'pg.showroom.descriptionReq': '描述 *',
    'pg.showroom.describeBusiness': '描述您的商家及您提供的内容',
    'pg.showroom.location': '位置',
    'pg.showroom.businessAddress': '商家地址',
    'pg.showroom.enterAddress': '输入您的商家地址',
    'pg.showroom.locationVerified': '位置已验证',
    'pg.showroom.contactOptions': '联系选项',
    'pg.showroom.email': '电子邮件',
    'pg.showroom.phone': '电话',
    'pg.showroom.enableChat': '启用聊天支持',
    'pg.showroom.enableCalling': '启用应用内通话',
    'pg.showroom.createShowroom': '创建展厅',
    'pg.showroom.managerTitle': '展厅管理器',
    'pg.showroom.managerSubtitle': '管理您的商家在市场中的形象',
    'pg.showroom.editShowroom': '编辑展厅',
    'pg.showroom.saveChanges': '保存更改',
    'pg.showroom.showroomInfo': '展厅信息',
    'pg.showroom.productsServices': '产品和服务',
    'pg.showroom.addProduct': '添加产品',
    'pg.showroom.all': '全部',
    'pg.showroom.active': '已上架',
    'pg.showroom.hidden': '已隐藏',
    'pg.showroom.noProductsYet': '暂无产品',
    'pg.showroom.noActiveProducts': '没有已上架的产品',
    'pg.showroom.noHiddenProducts': '没有已隐藏的产品',
    'pg.showroom.startShowcasing': '开始在市场中展示您的产品和服务。',
    'pg.showroom.addFirstProduct': '添加您的第一个产品',
    'pg.showroom.analyticsOverview': '分析概览',
    'pg.showroom.totalViews': '总浏览量',
    'pg.showroom.products': '产品',
    'pg.showroom.rating': '评分',
    'pg.showroom.viewFullAnalytics': '查看完整分析',
    'pg.customers.failedLoad': '加载客户失败',
    'pg.customers.noConversation': '未找到对话',
    'pg.customers.callInitiated': '通话已发起',
    'pg.customers.callLogged': '通话已记录',
    'pg.survey.createSurvey': '创建调查',
    'pg.survey.subtitle': '创建有吸引力的调查以收集客户反馈',
    'pg.survey.multipleChoice': '多项选择',
    'pg.survey.textResponse': '文本回答',
    'pg.survey.ratingScale': '评分量表',
    'pg.survey.yesNo': '是/否',
    'pg.survey.enterQuestion': '请在添加前输入问题',
    'pg.survey.questionAdded': '问题已添加',
    'pg.survey.questionAddedDesc': '问题已添加到调查中',
    'pg.survey.missingInfo': '信息缺失',
    'pg.survey.missingInfoDesc': '请填写所有必填字段并至少添加一个问题',
    'pg.survey.surveyCreated': '调查已创建！',
    'pg.survey.surveyCreatedDesc': '您的调查已成功创建，现在客户可以使用',
    'pg.survey.createFailed': '创建调查失败。请重试。',
    'pg.category.authNotReady': '身份验证尚未就绪',
    'pg.category.refreshTryAgain': '请刷新后重试。',
    'pg.category.failedLoadCategories': '加载反馈类别失败',
    'pg.category.customizationSaved': '类别自定义已成功保存',
    'pg.category.title': '反馈类别管理',
    'pg.category.subtitle': '管理和自定义您商家的反馈类别',
    'pg.director.title': '总监仪表板',
    'pg.director.livePerf': '实时团队绩效 —',
    'pg.director.teamProductivity': '团队生产力',
    'pg.director.workloadDistribution': '工作量分布',
    'pg.director.departmentKpis': '部门 KPI',
    'pg.director.resolutionRate': '解决率',
    'pg.director.ticketsResolved': '已解决工单',
    'pg.director.thisPeriod': '本期',
    'pg.director.avgFirstResponse': '平均首次响应',
    'pg.director.avgResolution': '平均解决',
    'pg.director.dailyResVsEsc': '每日解决与升级',
    'pg.director.liveUnavailable': '实时分析暂时不可用。请重试。',
    'pg.director.workspaceNotLinked': '您的账户尚未关联到工作区，因此无法加载分析。如果这不符合预期，请联系您的管理员。',
    'pg.exec.title': '高管仪表板',
    'pg.exec.liveMetrics': '实时运营指标 —',
    'pg.exec.days7': '7 天',
    'pg.exec.days30': '30 天',
    'pg.exec.days90': '90 天',
    'pg.exec.totalCustomers': '客户总数',
    'pg.exec.registeredPlatform': '已在平台注册',
    'pg.exec.aiResolutionRate': 'AI 解决率',
    'pg.exec.chatAutoResolved': '聊天自动解决',
    'pg.exec.customerCsat': '客户 CSAT',
    'pg.exec.noRatingsYet': '暂无评分',
    'pg.exec.escalationRate': '升级率',
    'pg.exec.failedLoad': '加载仪表板数据失败',
    'pg.it.title': 'IT 仪表板',
    'pg.it.tenantIntegrationOps': '租户集成运营 —',
    'pg.it.tenantScopedNotice': '仅显示租户范围的数据。平台/系统基础设施的运行状况由 Servisfy 管理，此处不显示。',
    'pg.it.connectors': '连接器',
    'pg.it.loading': '加载中…',
    'pg.it.failedConnectors': '加载连接器失败。',
    'pg.it.noConnectors': '尚未配置任何连接器。',
    'pg.it.openIntegrationHub': '打开集成中心',
    'pg.it.activeConfigured': '{active} 个活动 / {configured} 个已配置',
    'pg.it.enabled': '已启用',
    'pg.it.disabled': '已禁用',
    'pg.it.dataVolume': '数据量',
    'pg.it.conversations': '对话',
    'pg.it.escalations': '升级',
    'pg.it.liveTenantCounts': '实时租户记录数（IT 范围）。',
    'pg.it.workspaceNotLinked': '您的账户尚未关联到工作区，因此无法加载租户数据。如果这不符合预期，请联系您的管理员。',
  },
  ar: {
    'pg.billing.title': 'الفوترة والاشتراك',
    'pg.billing.subtitle': 'أدر خطتك واعرض الفواتير وقم بالترقية أو التخفيض.',
    'pg.billing.currentPlan': 'الخطة الحالية',
    'pg.billing.currentPlanDesc': 'اشتراكك النشط والحدود الرئيسية.',
    'pg.billing.tier': 'المستوى',
    'pg.billing.price': 'السعر',
    'pg.billing.brandId': 'معرّف العلامة التجارية',
    'pg.billing.status': 'الحالة',
    'pg.billing.users': 'المستخدمون',
    'pg.billing.engagements': 'التفاعلات / شهر',
    'pg.billing.storage': 'التخزين',
    'pg.billing.changePlan': 'تغيير الخطة',
    'pg.billing.changePlanDesc': 'اختر مستوى جديدًا — ستتم إعادة توجيهك إلى الدفع الآمن عبر Stripe.',
    'pg.billing.current': 'الحالية',
    'pg.billing.onRequest': 'عند الطلب',
    'pg.billing.contactSales': 'تواصل مع المبيعات',
    'pg.billing.switchPlan': 'التبديل إلى هذه الخطة',
    'pg.billing.currentPlanBtn': 'الخطة الحالية',
    'pg.billing.redirecting': 'جارٍ إعادة التوجيه…',
    'pg.billing.managePayments': 'إدارة طرق الدفع والإلغاءات',
    'pg.billing.managePaymentsDesc': 'افتح بوابة العملاء الآمنة من Stripe لتحديث بطاقتك أو تنزيل الإيصالات أو إلغاء اشتراكك.',
    'pg.billing.openingStripe': 'جارٍ فتح Stripe…',
    'pg.billing.redirectingCheckout': 'جارٍ إعادة التوجيه إلى الدفع…',
    'pg.billing.openPortal': 'فتح بوابة عملاء Stripe',
    'pg.billing.portalNotice': 'لا يوجد اشتراك مدفوع نشط بعد — سيؤدي النقر إلى فتح الدفع الآمن عبر Stripe لتفعيل خطتك. بعد الدفع، تصبح البوابة متاحة على الفور.',
    'pg.billing.invoiceHistory': 'سجل الفواتير',
    'pg.billing.invoiceHistoryDesc': 'أحدث جلسات الدفع عبر Stripe.',
    'pg.billing.noInvoices': 'لا توجد فواتير بعد.',
    'pg.billing.upgradeToStart': 'قم بالترقية إلى خطة مدفوعة لبدء الفوترة.',
    'pg.billing.date': 'التاريخ',
    'pg.billing.amount': 'المبلغ',
    'pg.billing.intent': 'الغرض',
    'pg.billing.paymentsSecure': 'تتم معالجة المدفوعات بأمان بواسطة Stripe.',
    'pg.mkt.searchPlaceholder': 'ابحث عن منتجات أو خدمات أو شركات...',
    'pg.mkt.allCategories': 'جميع الفئات',
    'pg.mkt.location': 'الموقع',
    'pg.mkt.recommended': 'موصى به لك',
    'pg.mkt.noRecommendations': 'لا توجد توصيات بعد.',
    'pg.mkt.browseCategories': 'تصفح الفئات',
    'pg.mkt.searchResultsFor': 'نتائج البحث عن "{query}"',
    'pg.mkt.allProducts': 'جميع المنتجات',
    'pg.mkt.productsFound': 'منتجات تم العثور عليها',
    'pg.mkt.newestFirst': 'الأحدث أولاً',
    'pg.mkt.priceLowHigh': 'السعر: من الأقل إلى الأعلى',
    'pg.mkt.priceHighLow': 'السعر: من الأعلى إلى الأقل',
    'pg.mkt.noPriceMatch': 'لا توجد منتجات في هذه الصفحة تطابق فلتر السعر الخاص بك.',
    'pg.mkt.page': 'صفحة',
    'pg.mkt.noProductsFound': 'لم يتم العثور على منتجات',
    'pg.mkt.adjustSearch': 'حاول تعديل معايير البحث أو تصفح فئات مختلفة.',
    'pg.mkt.clearFilters': 'مسح الفلاتر',
    'pg.mkt.productDetailsInfo': 'تفاصيل المنتج ومعلوماته',
    'pg.mkt.description': 'الوصف',
    'pg.mkt.price': 'السعر',
    'pg.mkt.tags': 'الوسوم',
    'pg.mkt.contactForPrice': 'اتصل لمعرفة السعر',
    'pg.mkt.addToFavorites': 'إضافة إلى المفضلة',
    'pg.mkt.contactBusiness': 'تواصل مع الشركة',
    'pg.mkt.contactBusinessSoon': 'ستتوفر قريبًا مراسلة الشركة مباشرة من السوق.',
    'pg.mkt.filterProducts': 'تصفية المنتجات',
    'pg.mkt.refineSearch': 'حسّن بحثك باستخدام فلاتر متقدمة',
    'pg.mkt.priceRange': 'نطاق السعر',
    'pg.mkt.min': 'الأدنى',
    'pg.mkt.max': 'الأقصى',
    'pg.mkt.category': 'الفئة',
    'pg.mkt.selectCategory': 'اختر فئة',
    'pg.mkt.clearAll': 'مسح الكل',
    'pg.mkt.applyFilters': 'تطبيق الفلاتر',
    'pg.showroom.createTitle': 'أنشئ صالة عرض شركتك',
    'pg.showroom.createSubtitle': 'قم بإعداد حضورك في السوق وابدأ في عرض منتجاتك وخدماتك',
    'pg.showroom.basicInfo': 'المعلومات الأساسية',
    'pg.showroom.businessNameReq': 'اسم الشركة *',
    'pg.showroom.enterBusinessName': 'أدخل اسم شركتك',
    'pg.showroom.descriptionReq': 'الوصف *',
    'pg.showroom.describeBusiness': 'صف شركتك وما تقدمه',
    'pg.showroom.location': 'الموقع',
    'pg.showroom.businessAddress': 'عنوان الشركة',
    'pg.showroom.enterAddress': 'أدخل عنوان شركتك',
    'pg.showroom.locationVerified': 'تم التحقق من الموقع',
    'pg.showroom.contactOptions': 'خيارات الاتصال',
    'pg.showroom.email': 'البريد الإلكتروني',
    'pg.showroom.phone': 'الهاتف',
    'pg.showroom.enableChat': 'تفعيل دعم الدردشة',
    'pg.showroom.enableCalling': 'تفعيل الاتصال داخل التطبيق',
    'pg.showroom.createShowroom': 'إنشاء صالة عرض',
    'pg.showroom.managerTitle': 'مدير صالة العرض',
    'pg.showroom.managerSubtitle': 'أدر حضور شركتك في السوق',
    'pg.showroom.editShowroom': 'تعديل صالة العرض',
    'pg.showroom.saveChanges': 'حفظ التغييرات',
    'pg.showroom.showroomInfo': 'معلومات صالة العرض',
    'pg.showroom.productsServices': 'المنتجات والخدمات',
    'pg.showroom.addProduct': 'إضافة منتج',
    'pg.showroom.all': 'الكل',
    'pg.showroom.active': 'نشط',
    'pg.showroom.hidden': 'مخفي',
    'pg.showroom.noProductsYet': 'لا توجد منتجات بعد',
    'pg.showroom.noActiveProducts': 'لا توجد منتجات نشطة',
    'pg.showroom.noHiddenProducts': 'لا توجد منتجات مخفية',
    'pg.showroom.startShowcasing': 'ابدأ في عرض منتجاتك وخدماتك في السوق.',
    'pg.showroom.addFirstProduct': 'أضف منتجك الأول',
    'pg.showroom.analyticsOverview': 'نظرة عامة على التحليلات',
    'pg.showroom.totalViews': 'إجمالي المشاهدات',
    'pg.showroom.products': 'المنتجات',
    'pg.showroom.rating': 'التقييم',
    'pg.showroom.viewFullAnalytics': 'عرض التحليلات الكاملة',
    'pg.customers.failedLoad': 'فشل تحميل العملاء',
    'pg.customers.noConversation': 'لم يتم العثور على محادثة',
    'pg.customers.callInitiated': 'تم بدء المكالمة',
    'pg.customers.callLogged': 'تم تسجيل المكالمة',
    'pg.survey.createSurvey': 'إنشاء استطلاع',
    'pg.survey.subtitle': 'أنشئ استطلاعات جذابة لجمع ملاحظات العملاء',
    'pg.survey.multipleChoice': 'اختيار من متعدد',
    'pg.survey.textResponse': 'إجابة نصية',
    'pg.survey.ratingScale': 'مقياس التقييم',
    'pg.survey.yesNo': 'نعم/لا',
    'pg.survey.enterQuestion': 'يرجى إدخال سؤال قبل الإضافة',
    'pg.survey.questionAdded': 'تمت إضافة السؤال',
    'pg.survey.questionAddedDesc': 'تمت إضافة السؤال إلى الاستطلاع',
    'pg.survey.missingInfo': 'معلومات ناقصة',
    'pg.survey.missingInfoDesc': 'يرجى ملء جميع الحقول المطلوبة وإضافة سؤال واحد على الأقل',
    'pg.survey.surveyCreated': 'تم إنشاء الاستطلاع!',
    'pg.survey.surveyCreatedDesc': 'تم إنشاء استطلاعك بنجاح وأصبح متاحًا الآن للعملاء',
    'pg.survey.createFailed': 'فشل إنشاء الاستطلاع. يرجى المحاولة مرة أخرى.',
    'pg.category.authNotReady': 'المصادقة غير جاهزة',
    'pg.category.refreshTryAgain': 'يرجى التحديث والمحاولة مرة أخرى.',
    'pg.category.failedLoadCategories': 'فشل تحميل فئات الملاحظات',
    'pg.category.customizationSaved': 'تم حفظ تخصيص الفئة بنجاح',
    'pg.category.title': 'إدارة فئات الملاحظات',
    'pg.category.subtitle': 'أدر وخصص فئات الملاحظات لشركتك',
    'pg.director.title': 'لوحة المدير',
    'pg.director.livePerf': 'أداء الفريق المباشر —',
    'pg.director.teamProductivity': 'إنتاجية الفريق',
    'pg.director.workloadDistribution': 'توزيع عبء العمل',
    'pg.director.departmentKpis': 'مؤشرات أداء القسم',
    'pg.director.resolutionRate': 'معدل الحل',
    'pg.director.ticketsResolved': 'التذاكر المحلولة',
    'pg.director.thisPeriod': 'هذه الفترة',
    'pg.director.avgFirstResponse': 'متوسط أول استجابة',
    'pg.director.avgResolution': 'متوسط الحل',
    'pg.director.dailyResVsEsc': 'الحل مقابل التصعيد اليومي',
    'pg.director.liveUnavailable': 'التحليلات المباشرة غير متاحة مؤقتًا. يرجى المحاولة مرة أخرى.',
    'pg.director.workspaceNotLinked': 'حسابك غير مرتبط بمساحة عمل بعد، لذا لا يمكن تحميل التحليلات. تواصل مع المسؤول إذا كان هذا غير متوقع.',
    'pg.exec.title': 'اللوحة التنفيذية',
    'pg.exec.liveMetrics': 'المقاييس التشغيلية المباشرة —',
    'pg.exec.days7': '7 أيام',
    'pg.exec.days30': '30 يومًا',
    'pg.exec.days90': '90 يومًا',
    'pg.exec.totalCustomers': 'إجمالي العملاء',
    'pg.exec.registeredPlatform': 'مسجلون في المنصة',
    'pg.exec.aiResolutionRate': 'معدل الحل بالذكاء الاصطناعي',
    'pg.exec.chatAutoResolved': 'تم حل الدردشة تلقائيًا',
    'pg.exec.customerCsat': 'رضا العملاء (CSAT)',
    'pg.exec.noRatingsYet': 'لا توجد تقييمات بعد',
    'pg.exec.escalationRate': 'معدل التصعيد',
    'pg.exec.failedLoad': 'فشل تحميل بيانات اللوحة',
    'pg.it.title': 'لوحة تقنية المعلومات',
    'pg.it.tenantIntegrationOps': 'عمليات تكامل المستأجر —',
    'pg.it.tenantScopedNotice': 'بيانات نطاق المستأجر فقط. تتم إدارة صحة البنية التحتية للمنصة/النظام بواسطة Servisfy ولا تظهر هنا.',
    'pg.it.connectors': 'الموصّلات',
    'pg.it.loading': 'جارٍ التحميل…',
    'pg.it.failedConnectors': 'فشل تحميل الموصّلات.',
    'pg.it.noConnectors': 'لم يتم تكوين أي موصّلات بعد.',
    'pg.it.openIntegrationHub': 'فتح مركز التكامل',
    'pg.it.activeConfigured': '{active} نشط / {configured} مكوَّن',
    'pg.it.enabled': 'مُفعّل',
    'pg.it.disabled': 'مُعطّل',
    'pg.it.dataVolume': 'حجم البيانات',
    'pg.it.conversations': 'المحادثات',
    'pg.it.escalations': 'التصعيدات',
    'pg.it.liveTenantCounts': 'أعداد سجلات المستأجر المباشرة (نطاق تقنية المعلومات).',
    'pg.it.workspaceNotLinked': 'حسابك غير مرتبط بمساحة عمل بعد، لذا لا يمكن تحميل بيانات المستأجر. تواصل مع المسؤول إذا كان هذا غير متوقع.',
  },
};

export default pagesTranslations;
